var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "État",
    "history": "Énergie",
    "layout": "Champ PV",
    "menu": "Menu"
  },
  "button": {
    "cancel": "Annuler",
    "done": "Terminé",
    "login": "Se connecter",
    "today": "Aujourd'hui",
    "submit": "Soumettre",
    "ok": "D'accord",
    "choose_file": "Choisir fichier",
    "refresh": "Rafraîchir",
    "send": "Envoyer",
    "skip": "Sauter",
    "clickHere": "Cliquez ici",
    "confirm": "Confirmer",
    "reset": "Réinitialiser",
    "edit": "Modifier",
    "update": "Mise à jour",
    "next": "Suivant",
    "save": "Enregistrer",
    "no": "Non",
    "yes": "Oui",
    "enable": "Activer",
    "setNow": "Définir maintenant",
    "gotIt": "D’accord",
    "okGotIt": "J’ai compris",
    "continue": "Continuer",
    "knowMore": "En savoir plus",
    "noExportCredit": "Je n’ai pas de crédit à l’exportation",
    "tryLater": "Essayez plus tard",
    "otherNetworks": "Autres réseaux"
  },
  "form": {
    "topic": "Sujet",
    "contactSupport": {
      "success": {
        "message": "Merci de nous avoir contactés.",
        "description": "Nous mettons tout en œuvre pour résoudre votre problème au plus tôt. Un spécialiste Enphase vous contactera dans les plus brefs délais.",
        "email_notify": "Le rapport sera envoyé sous peu à %{email}."
      },
      "error": {
        "message": "Échec de l'envoi du message.",
        "description": "Veuillez réessayer.",
        "reset_password": "Mot de passe expiré. Veuillez réinitialiser le mot de passe."
      }
    },
    "default": {
      "success": "Sauvegarde effectuée avec succès",
      "error": "Merci de réessayer",
      "pleaseEnterAValue": "Veuillez entrer une valeur",
      "permissionDenied": "Permission refusée",
      "activeBatteryProfile": "Vous avez une demande en cours concernant le Profil de batterie. Attendez confirmation ou annulez cette demande pour continuer."
    },
    "search": "Recherche"
  },
  "common": {
    "please": "Veuillez",
    "contactSupport": "contacter l’assistance",
    "forHelp": "pour obtenir de l’aide.",
    "videos": "Vidéos",
    "articles": "Articles",
    "new": "Nouveau",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "clearedDate": "Date effacée",
    "startTime": "Heure de début",
    "endTime": "Heure de fin",
    "duration": "Durée"
  },
  "errors": {
    "error": "Erreur",
    "errors": "Erreurs",
    "warning": "Warning",
    "retry": "Réessayer",
    "email": "Saisissez une adresse e-mail valide",
    "password": "Saisissez votre mot de passe",
    "login": "L'e-mail et le mot de passe saisis ne correspondent pas aux données dont nous disposons.",
    "accInactive": "Le compte est inactif. Veuillez contacter votre installateur et réessayer une fois que votre système sera pleinement actif.",
    "expired": "Votre connexion a expiré.",
    "loggedout": "Vous avez été déconnecté.",
    "report": "Désolé, une erreur est survenue.",
    "offline": "Veuillez vérifier votre connexion Internet et réessayer.",
    "noInternet": "Pas d’Internet",
    "message": "Message",
    "tryagain": "Réessayer",
    "resetNow": "Réinitialiser maintenant",
    "resetPassword": "Votre mot de passe a expiré. Veuillez le réinitialiser pour consulter le rapport",
    "validEmail": "Veuillez entrer une adresse email valide",
    "validPhone": "Veuillez saisir un numéro de téléphone valide",
    "fileError": "Le logo de l'entreprise doit être compris entre 0,05 Ko et 4 Mo.",
    "400": "Demande incorrecte",
    "401": "Accès non autorisé",
    "403": "Accès interdit",
    "404": "Ressource introuvable",
    "422": "Entité ne pouvant pas être traitée",
    "500": "Erreur interne du serveur.",
    "502": "Passerelle incorrecte.",
    "503": "Service indisponible.",
    "504": "Expiration de la passerelle.",
    "default": "Erreur de serveur.",
    "400_text": "Demande incorrecte",
    "401_text": "Accès non autorisé",
    "403_text": "Accès interdit",
    "404_text": "Ressource introuvable",
    "422_text": "Entité ne pouvant pas être traitée",
    "500_text": "Erreur interne du serveur. Réessayez plus tard.",
    "502_text": "Passerelle incorrecte. Réessayez plus tard.",
    "503_text": "Service indisponible. Réessayez plus tard.",
    "504_text": "Expiration de la passerelle. Réessayez plus tard.",
    "default_text": "Erreur de serveur. Réessayez plus tard.",
    "noDeviceFound": "Aucun appareil trouvé",
    "noBackupHistoryFound": "Aucun historique de sauvegarde trouvé",
    "noWiFiNetworkFound": "Aucun réseau Wi-Fi",
    "noResultFound": "Aucun résultat trouvé",
    "allSites": "Tous Les Sites",
    "favorites": "Favoris",
    "changesNotSaved": "Les modifications ne sont pas enregistrées",
    "wantToExit": "Voulez-vous quitter sans enregistrer ?",
    "rateNotFound": "Impossible de trouver le taux"
  },
  "login": {
    "forgot": "Mot de passe oublié",
    "signup": "Nouveau compte",
    "header": "Se connecter à Enphase",
    "intro_content": "Merci de saisir votre adresse email d'enregistrement chez Enphase.  Vous recevrez un mail avec un lien pour réinitialiser un nouveau mot de passe.",
    "remember_me": "Mémoriser mes informations",
    "forgot_password": "Vous avez oublié votre mot de passe ?",
    "forgot_password_success": "Si vous vous êtes déjà enregistré sur Enphase, veuillez consulter votre email pour obtenir des instructions de réinitialisation.",
    "caps_lock_warning": "Touche MajVerr activée",
    "welcome_back": "Bienvenue, %{user_name}. ",
    "en_us_installer_html": "Bienvenue %{user_name}. Visitez notre <a href='http://go.enphase.com/gettingstarted' target='_blank'>site de démarrage</a> pour apprendre tout ce que vous devez savoir sur la conception, l'installation et la mise en service des systèmes Enphase. ",
    "en_aunz_installer_html": "Bienvenue %{user_name}. Visitez notre <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>site de démarrage</a> pour apprendre tout ce que vous devez savoir sur la conception, l'installation et la mise en service des systèmes Enphase. ",
    "provide_email_password": "Fournissez un nom d'utilisateur et un mot de passe.",
    "request_account": "Demander un compte",
    "subheader": {
      "new_user": "Nouveau sur Enphase ?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Les produits Enphase Energy améliorent de façon spectaculaire les performances des installations PV. Grâce aux micro-onduleurs Enphase, les propriétaires et opérateurs augmentent la productivité et la fiabilité de leur installation.<br/><br/>Pour voir Enphase en action, <a href='%{systems_list_link}'>venez visiter les installations de nos clients.</a>",
    "public_system_content_html": "Vous voulez voir Enphase en action ? <a href='%{systems_list_link}'>Voir les systèmes publics</a>",
    "register_new_user_html": "Vous installez votre premier système Enphase ? <a href='%{register_user_link}'>S’inscrire à Enphase</a>",
    "recommended_browsers": "L’application Enphase est compatible avec les navigateurs suivants : Chrome 5 ou supérieur, Firefox 3.6 ou supérieur, Internet Explorer 10 ou supérieur, Microsoft Edge pour Windows, Safari 4 ou supérieur. L’application Enphase nécessite Adobe Flash Player 10.",
    "recommended_browsers_3x": "L’application Enphase est compatible avec les navigateurs suivants : Chrome 44 ou supérieur, Firefox 41 ou supérieur, Internet Explorer 11, Microsoft Edge pour Windows, Safari 8 ou supérieur.",
    "cookies_required": "Les cookies doivent être activés.",
    "no_community": "Cette communauté est réservée aux discussions techniques pour les installateurs Enphase. Nous vous invitons à participer aux discussions sur notre <a href='https://www.facebook.com/EnphaseEnergy'>page Facebook</a>.",
    "required": "Vous devez vous connecter pour accéder à cette page",
    "findInstaller": "Trouver un installateur",
    "sizeYourSystem": "Mesurer votre système",
    "getEnphase": "Obtenir Enphase",
    "experienceTheApp": "Application expérience",
    "viewStorageSystem": "Regarder la vidéo",
    "meetEnphase": "Rencontrez Enphase",
    "enphaseSolar": "Enphase Solaire",
    "enphaseStorage": "Enphase Stockage"
  },
  "logout": {
    "confirm_logout": "Vous avez été déconnecté. Merci de votre visite."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Activer le compte",
      "link": "Activez votre compte maintenant"
    },
    "header": "Réinitialisation du mot de passe",
    "intro_content": "Pour demander la réinitialisation de votre mot de passe, saisissez votre adresse e-mail dans la zone ci-dessous et cliquez sur Soumettre. Vous allez recevoir un e-mail comportant des instructions sur la réinitialisation du mot de passe.",
    "login": "Se connecter",
    "try_again": "Réessayez.",
    "sent_message_html": "Si vous êtes déjà enregistré auprès d'Enlighten, consultez vos e-mails pour obtenir les instructions de réinitialisation. <span style='color:red'>Si vous n'avez pas reçu l'email, veuillez vérifier dans vos spams/courriers indésirables.</span>",
    "invalid_request": "Requête non valide",
    "invalid_link": "Impossible de réinitialiser le mot de passe. Le lien de réinitialisation du mot de passe est valide pendant 7 jours. Réessayez.",
    "success": "Mot de passe réinitialisé correctement.",
    "failed_password_reset": "Un problème est survenu. Réessayez.",
    "password_requirements": "Votre mot de passe doit comporter au moins six caractères, doit contenir au moins un chiffre ou un caractère spécial et ne peut pas être identique à votre adresse électronique.",
    "note": "Mot de passe ",
    "OK": "D'accord",
    "sent_email": "Nous avons envoyé un mail à l'adresse suivante",
    "rest_pwd": "Cliquez sur le lien dans le mail pour créer un nouveau mot de passe."
  },
  "users": {
    "new": "Nouvel abonnement utilisateur",
    "company_details": "Détails entreprise",
    "edit": "Modifier l'utilisateur",
    "site_accesses": "Accès système",
    "login": "Se connecter",
    "logged_in_as": "%{admin}, vous êtes connecté en tant que %{user}",
    "logout_as": "Arrêter",
    "reset_password": "Réinitialiser le mot de passe",
    "preview_marketing_description": "Aperçu seulement. Les modifications n'ont pas encore été enregistrées.",
    "preview_custom_welcome_message": "Aperçu seulement. Les modifications n'ont pas encore été enregistrées.",
    "reset_password_confirm_html": "<b>Voulez-vous vraiment réinitialiser le mot de passe de cet utilisateur ?</b><p>Cette opération active l'utilisateur, génère un nouveau mot de passe et envoie un e-mail de bienvenue à l'utilisateur.</p>",
    "reset_password_success": "Mot de passe réinitialisé correctement. Un e-mail de bienvenue sera envoyé à %{email} pour expliquer comment se connecter.",
    "reset_password_failed": "Échec de réinitialisation du mot de passe.",
    "enlighten_manager_access": "Cet utilisateur a Enlighten Manager avec un accès aux données au niveau du module.",
    "myenlighten_access_note": "(uniquement pour les utilisateurs qui ne sont PAS associés à une entreprise)",
    "module_level_access_note": "(avec un accès aux données au niveau du module)",
    "complimentary_note": "REMARQUE : le passage de MyEnlighten à Enlighten Manager constitue l'abandon d'une activation logicielle dont la valeur est de %{price}. Cette transaction sera enregistrée et envoyée au service financier.",
    "purchase_note": "L'activation logicielle a été achetée par %{email} pour %{price} le %{date}.",
    "enlighten_version_title": "Version de l’application Enphase",
    "unlock_account": "Déverrouiller le compte",
    "cameraText": "Cela vous permettra de sélectionner l'image que vous souhaitez télécharger comme logo de votre entreprise.",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "J'installe moi-même des produits Enphase à mon domicile ou dans mon entreprise",
    "self_installer_false": "Je suis un professionnel de l'énergie PV et je m'inscris au nom de mon entreprise",
    "self_register_independent": "Autre",
    "opt_in": "J'accepte de recevoir des newsletters, des promotions et des enquêtes sur les services ou les produits Enphase.",
    "opt_in_info": "Vous pouvez changer d'avis à tout moment. Pour plus d'informations, reportez-vous à la <a href='%{privacy_url}' target='_blank'>politique de confidentialité </a> d'Enphase ou <a href='%{contact_url}' target='_blank'>contactez-nous</a>.",
    "personal_details": "Coordonées personnelles",
    "enable_camera": "Activer l'accès à la caméra pour votre application à partir de l'onglet Paramètres",
    "dont_allow": "Ne pas permettre"
  },
  "forecast": {
    "nodata": "Les données prévisionnelles ne sont pas disponibles !",
    "nodata5": "Nous avons besoin d’au moins 5 jours de données de production pour prévoir avec précision les données de production.",
    "nodata10": "Nous avons besoin d'au moins 5 jours de données de production au cours des 15 derniers jours pour afficher vos prévisions.",
    "apifail": "Impossible d’afficher les données prévisionnelles !",
    "apifailSub": "Erreur lors de l'affichage des données prévisionnelles en raison de problèmes techniques. Veuillez vérifier après un certain temps.",
    "weatherErr": "Erreur lors de l'affichage des données prévisionnelles en raison de l'indisponibilité des données météorologiques.",
    "weatherProdErr": "Erreur d'affichage des données prévisionnelles en raison de l'indisponibilité des données de production ou météorologiques.",
    "genErr": "Erreur lors de l'affichage des données prévisionnelles en raison de problèmes techniques.",
    "envoyErr1": "Les données de production ne sont pas disponibles car votre passerelle ne communique pas avec le cloud.",
    "envoyErr2": "Les données de production ne sont pas disponibles car votre passerelle ne communique pas avec le cloud.",
    "microErr1": "Les données de production ne sont pas disponibles, car aucun des micro-onduleurs ne signale",
    "microErr2": "Les données de production ne sont pas mises à jour car aucun des micro-onduleurs ne signale",
    "accCTA": "Pourquoi votre production actuelle est différente des prévisions ?",
    "ctainfo": "Les prévisions ne sont qu’une prédiction pour vous aider à planifier vos besoins en énergie. Veuillez noter que vos valeurs de production peuvent être différentes des prévisions.",
    "ctainfoRes": "Raisons possibles des différences entre la production réelle et les prévisions",
    "ctainfoRes1": "Changements météorologiques fréquents dans votre localité",
    "ctainfoRes2": "Certains de vos micro-onduleurs n’envoient pas de rapport",
    "ctainfoRes3": "Votre système n’a pas envoyé de rapport depuis plus d’un jour",
    "today": "Aujourd'hui",
    "forecast": "Prévisions",
    "actual": "Réel",
    "timeFrom": "Affichage à 12:00 matin",
    "actualProd": "Actual Production",
    "sunrise": "Lever du soleil",
    "sunset": "Coucher du soleil",
    "clearDay": "Plutôt ensoleillé",
    "clearNight": "Mostly clear",
    "rain": "Plutôt pluvieux",
    "snow": "Plutôt enneigé",
    "sleet": "Plutôt de la neige fondue",
    "wind": "Plutôt venteux",
    "fog": "Plutôt brumeux",
    "cloudy": "Nuageux",
    "partlycloudy": "Partiellement nuageux",
    "unknown": "Unknown",
    "at12": "À 12:00 matin",
    "title": "Connaître vos prévisions de production",
    "infoIconPopup": "Les prévisions de production est la prédiction de la quantité d’énergie que vos panneaux produiraient aujourd’hui et pendant les 5 prochains jours. Les prévisions sont calculés sur la base de votre précédente production d’énergie et sur les prévisions météorologiques dans votre région.",
    "fiveday": "Prévisions sur 5 jours",
    "tomo": "Demain"
  },
  "user": {
    "id": "ID utilisateur",
    "api_key": "Clé API",
    "company": "Entreprise",
    "company_id": "ID d'entreprise",
    "consumer": "MyEnlighten",
    "country": "Pays",
    "email": "Adresse email",
    "email_confirm": "Confirmer l'e-mail",
    "password": "Mot de passe",
    "first_name": "Prénom",
    "last_name": "Nom",
    "sfdc_email": "Email",
    "sfdc_subject": "Sujet",
    "sfdc_message": "Message",
    "sfdc_siteId": "Identifiant du site Enphase",
    "created_at": "Créé à",
    "name": "Nom",
    "updated_at": "Mis à jour à",
    "status": "État",
    "phone": "Téléphone",
    "locale": "Langue préférée",
    "preferred_metric": "Unités",
    "preferred_alert_level": "Niveau d'alerte par défaut",
    "preferred_array_builder": "Peut générer des champs PV",
    "preferred_show_dashboard_help": "Préférence d'aide sur le tableau de bord",
    "preferred_new_look": "Présentation d'Enlighten 3.0",
    "preferences": "Préférences",
    "role": "Rôle",
    "roles_mask": "Masque des rôles",
    "sales_demo": "Démonstration de vente",
    "sees_modules": "Voit les données du module",
    "notes": "Notes",
    "prefers_monthly_email": "S'inscrire à l'e-mail mensuel",
    "preferred_enphase_email": "Recevoir des e-mails d'Enphase",
    "prefers_privacy_policy_assent": "Politique de confidentialité acceptée",
    "active": "Active",
    "inactive": "Inactif",
    "add_user": "Ajouter un utilisateur",
    "self_installer": "Utilisateur installateur",
    "site_access_id": "ID du site",
    "user_access_id": "ID utilisateur",
    "with_company": "Inclure détails entreprise dans mon abonnement",
    "last_login": "Dernière connexion",
    "acknowledge": "Je reconnais avoir lu et accepté Enphase",
    "privacy_url": "Politique de confidentialité",
    "terms_url": "Conditions d'utilisation",
    "acknowledgementHead": "J’ai lu d’Enphase",
    "acknowledgementBody": "ainsi que les et les accepte"
  },
  "company": {
    "id": "ID d'entreprise",
    "active_users": "Utilisateurs actifs",
    "address1": "Adresse (ligne 1)",
    "optional": "Optionnel",
    "address2": "Adresse (ligne 2)",
    "address_id": "Emplacement",
    "branch_name": "Nom de la filiale",
    "branch_of": "Filiale de",
    "city": "Ville",
    "companies": "Filiales",
    "country": "Pays",
    "duplicate_of": "Remplacé par",
    "latitude": "Latitude",
    "logo_img": "Logo de l'entreprise",
    "file_type_size": "Doit être un fichier JPEG ou PNG ne dépassant pas 4 Mo.",
    "file_recommendation": "Pour de meilleurs résultats, nous recommandons une image carrée avec un arrière-plan transparent d’au moins 400 pixels de large par 400 pixels de haut.",
    "logo_img_file_size": "Logo de l'entreprise",
    "logo_img_content_type": "Logo de l'entreprise",
    "longitude": "Longitude",
    "long_name": "Nom de l'entreprise",
    "marketing_description": "Description de l'entreprise",
    "custom_welcome_message": "E-mail de bienvenue au client",
    "show_logo_in_welcome_email": "Afficher le logo de l'entreprise dans l'e-mail de bienvenue au client",
    "name": "Nom",
    "parent": "Maison mère",
    "phone": "Téléphone",
    "role": "Rôle",
    "roles": {
      "admin": "Support technique/Centre d'appels",
      "installer": "Installateur",
      "distributor": "Distributeur",
      "third_party_owner": "Propriétaire tiers"
    },
    "state": "Département/Région",
    "support_email": "E-mail de l'assistance clientèle",
    "support_phone": "Numéro de téléphone de l'assistance clientèle",
    "timezone": "Fuseau horaire",
    "url": "URL du site Internet",
    "zip": "Code postal",
    "is_installer": "Cette entreprise installe des systèmes Enphase",
    "errors": {
      "name_not_found": "Nom de l'entreprise introuvable"
    },
    "success": {
      "msg": "Votre compte a été créé. Veuillez vérifier votre courrier électronique pour savoir comment vous connecter."
    }
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Notre politique de confidentialité a été modifiée avec prise d'effet le %{policy_date}",
      "link_body": "<a href='%{privacy_url}' target='_blank'>Voir la politique de confidentialité</a>",
      "acknowledgement": "Je déclare avoir lu et accepte les termes de la <a href='%{privacy_url}' target='_blank'>politique de confidentialité</a> d'Enphase.",
      "continue_button": "Continuer",
      "privacy_settings_button": "Poursuivre vers Paramètres de confidentialité",
      "privacy_policy_agreement_required": "Je déclare avoir lu et accepte les termes de la <a target='_blank' href='%{privacy_url}'>politique de confidentialité</a> d'Enphase\nainsi que les <a target='_blank' href='%{terms_url}'>conditions d'utilisation</a>.\n"
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "Ce champ est obligatoire."
    }
  },
  "period": {
    "hours": "Jour",
    "days": "Mois",
    "week": "La semaine",
    "months": "An",
    "years": "Durée d'exploitation",
    "custom": "Personnalisé"
  },
  "validate": {
    "privacy_policy_accept": "Si vous n’acceptez pas les conditions de la politique de confidentialité et des conditions de service d’Enphase, vous ne pouvez pas vous inscrire à l’application Enphase."
  },
  "history": {
    "totals": "Totaux",
    "graph": "Domicile",
    "production": "Produit",
    "consumption": "Consommé",
    "grid": "Utilitaire",
    "export": "Exporté",
    "import": "Importé",
    "netExported": "Net exporté",
    "netImported": "Net importé",
    "battery": "Batterie",
    "charge": "Chargée",
    "discharge": "Déchargée",
    "soc": "Batterie",
    "hours": "",
    "months": "",
    "today": "Aujourd'hui",
    "battery_status": "Charge",
    "bulbs": "Ampoule 100 W",
    "last_updated": "Mis à jour",
    "power": "Puissance",
    "solar_produced": "Produit solaire",
    "solar_consumed": "Solaire consommée",
    "saved": "Enregistré",
    "emission_saved": "Emission de CO2 économisée",
    "refrigerator": "Réfrigérateur",
    "produced_today": "Produit aujourd'hui",
    "produced_yesterday": "Produit hier",
    "this_week": "Cette semaine",
    "last_week": "La semaine dernière",
    "this_month": "Ce mois-ci",
    "last_month": "Le mois dernier",
    "this_year": "Cette année",
    "selected_day": "Jour Sélectionné",
    "previous_day": "Jour Précédent",
    "selected_week": "Semaine Sélectionnée",
    "previous_week": "Semaine Précédente",
    "selected_month": "Mois Sélectionné",
    "previous_month": "Mois Précédent",
    "selected_year": "Année Sélectionnée",
    "previous_year": "Année Précédente",
    "last_year": "L'année dernière",
    "produced_this_week": "Produit cette semaine",
    "produced_last_week": "Produit la semaine dernière",
    "produced_this_year": "Produit cette année",
    "produced_last_year": "Produit l'an dernier",
    "produced_this_month": "Produit ce mois-ci",
    "produced_last_month": "Produit le mois dernier",
    "produced_lifetime": "Durée de vie produite",
    "imported-exported": "Importé/Exporté",
    "yesterday": {
      "hours": "Hier",
      "days": "Mois dernier",
      "months": "L'an dernier",
      "years": "Produit"
    },
    "lastyear": {
      "hours": "L'an dernier",
      "days": "L'an dernier",
      "months": "L'an dernier",
      "years": "Produit"
    },
    "generator": "Générateur"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Choisissez la fréquence des données",
      "daily": "du quotidien / journalier",
      "weekly": "Hebdomadaire",
      "monthly": "Mensuel",
      "yearly": "Annuel",
      "generateReport": "Nous avons besoin d'au moins une semaine de données pour générer le rapport"
    }
  },
  "calendar": {
    "select": "Choisir une date",
    "scale": {
      "production": "Production",
      "consumption": "Consommé"
    },
    "weekDays": {
      "monday": "Lundi",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Vendredi",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "Janvier",
      "february": "Février",
      "march": "Mars",
      "april": "Avril",
      "may": "Mai",
      "june": "Juin",
      "july": "Juillet",
      "august": "Aout",
      "september": "Septembre",
      "october": "Octobre",
      "november": "Novembre",
      "december": "Décembre",
      "jan": "janv.",
      "feb": "févr.",
      "mar": "mars",
      "apr": "avril",
      "jun": "juin",
      "jul": "juil.",
      "aug": "août",
      "sep": "sept.",
      "oct": "oct.",
      "nov": "nov.",
      "dec": "déc."
    },
    "time": {
      "hour": "heure",
      "hours": "heure",
      "minute": "minute",
      "minutes": "minutes",
      "second": "deuxième",
      "seconds": "secondes",
      "millisecond": "milliseconde",
      "milliseconds": "millisecondes",
      "day": "jour",
      "h": "h",
      "min": "min"
    }
  },
  "status": {
    "nameChangeNormal": "Normal",
    "nameChangeError": 'Erreur',
    "nameChangeWarning": 'Avertissement',
    "latest_solar_power": "Latest Solar Power",
    "dayTitle": "État du jour",
    "dayAltTitle": "Dernier état",
    "monthTitle": "État du mois en cours",
    "monthAltTitle": "Dernier état mensuel",
    "yearTitle": "État de l'année en cours",
    "yearAltTitle": "Dernier état annuel",
    "lifetimeTitle": "État de la durée d'exploitation",
    "lifetime": "Durée",
    "system_normal": "Système normal",
    "system_error": "Erreur système",
    "energyConsumed": "Énergie Consommée",
    "energyProduced": "Énergie Produite",
    "powerProduced": "Puissance Produite",
    "powerConsumed": "Puissance Consommée",
    "moreDetails": "Plus de détails",
    "latest_power": "Dernière Puissance PV",
    "peak_power": "Pic de Puissance PV",
    "latest_power_text": "L’Énergie solaire la plus récente est la puissance de sortie la plus récemment rapportée de votre système PV",
    "peak_power_text": "L’énergie maximum est la puissance de sortie maximum de votre système PV pour la période choisie",
    "addEnphaseStorage": "Ajouter une batterie Enphase",
    "getAQuote": "Obtenez un devis",
    "production": {
      "title": "Solaire",
      "label": "Produit",
      "section": "Destinations de l'énergie"
    },
    "consumption": {
      "title": "Utilisation",
      "label": "Consommé",
      "section": "Sources d'énergie"
    },
    "grid": {
      "title": "Énergie nette",
      "export": "Exporté",
      "import": "Importé",
      "label": "Énergie nette avec importation/exportation",
      "section": "Sources d'énergie",
      "progressbarTitle": "Énergie nette à partir du réseau"
    },
    "breakdown": {
      "consumption": "Domicile",
      "battery": "Stockage",
      "production": "Solaire",
      "grid": "Fournisseur",
      "export": "Exporté",
      "import": "Importé",
      "soc": "Stocké",
      "total": "Total",
      "peak": "Puissance de crête",
      "latest": "Puissance la plus récente",
      "next": "Prochain rapport"
    },
    "battery": {
      "title": "Stockage",
      "label": {
        "none": "Inactif",
        "positive": "Charge",
        "negative": "Décharge"
      },
      "section": "Énergie disponible"
    },
    "charge": "Charge",
    "stormAlertOn": "Alerte orage : On",
    "batteryProfile": "profil de batterie",
    "batteryInfo1": "Selon la consommation des dernières 24 heures (%{consumption}) votre système Enphase fonctionnera pendant environ ",
    "batteryInfo2": " sans électricité provenant du réseau ou des panneaux.",
    "batteryInfoWOSolar": " sans électricité provenant.",
    "batteryErrorInfo": "Nous n’avons pas suffisamment de données pour estimer la durée de sauvegarde de votre batterie.",
    "to": "À",
    "batteryZeroErrorInfo": "Vous n'avez aucune heure d'autonomie puisque vos batteries sont déchargées.",
    "hours": "heure(s)",
    "minutes": "minute(s)",
    "gridControls": {
      "verifyOtp": "Vérifier le code",
      "verificationCode": "Code de vérification",
      "offGridContent": "Vous perdrez la connexion au réseau. L’énergie disponible à la consommation sera restreinte.",
      "tryAgainContent": "Impossible d’établir une connexion avec la passerelle.",
      "verifyOtpEmail": "Saisissez le code à quatre chiffres qui a été envoyé à l’adresse e-mail que vous avez enregistrée.",
      "verifyOtpEmailMobile": "Saisissez le code à quatre chiffres qui a été envoyé à l’adresse e-mail que vous avez enregistrée et le numéro de téléphone mobile.",
      "verifyOtpUpdateMobile": "Un code à quatre chiffres sera envoyé à l’adresse e-mail que vous avez enregistrée.",
      "onGridContent": "Voulez-vous reconnecter votre système au réseau maintenant ?",
      "pleaseTryAgain": "Veuillez réessayer",
      "enterValidOtp": "Veuillez fournir un code valide.",
      "didntReceiveOtp": "Vous n’avez pas reçu le code ?",
      "goOffGrid": "Se déconnecter du réseau",
      "goOnGrid": "Se connecter au réseau",
      "tryAgain": "réessayer",
      "resend": "Envoyer à nouveau",
      "alert": "L'accès au contrôle du réseau est désactivé car une mise à jour de votre système est en cours. Cette mise à jour peut prendre jusqu'à 24 heures. Veuillez attendre la fin de la mise à jour.",
      "sendCode": "Envoyer le code",
      "mobileStatus": "pour recevoir un code par texto.",
      "myInfoButton": "Mettez à jour votre numéro de téléphone mobile",
      "wpc1l1": "Vos niveaux de consommation actuels sont supérieurs à la production d’énergie solaire disponible.  Veuillez réduire votre consommation pour éviter l’arrêt du système lors de la transition.​",
      "wpc1l2": "Vous pouvez voir votre production solaire actuelle et la consommation des charges essentielles dans %{liveStatus}.",
      "wpc2l1": "Votre consommation moyenne au cours des 15 dernières minutes est supérieure à votre production moyenne d’énergie solaire. Veuillez vous assurer que votre production solaire actuelle est suffisante pour répondre à vos demandes de consommation afin d’éviter l’arrêt du système lorsque vous êtes déconnecté du réseau.",
      "wpcOnGrid": "Votre système est actuellement alimenté par le générateur. Passer au mode Connecté au réseau pourrait entraîner une perturbation temporaire du courant si votre consommation est très élevée. Veuillez réduire votre consommation pour éviter cette perturbation.",
      "wpcOnGrid2": "Vous pouvez voir votre consommation actuelle dans %{liveStatus}."
    },
    "viewDetails": "Voir les détails",
    "socMessageError1": "Le ",
    "socMessageError2": " d’espace de stockage exclut les pourcentages de stockage de ",
    "socMessageError3": " Batterie(s)",
    "socMessageThreshold": "Le niveau de charge de la batterie ne peut pas être déterminé, car aucune des batteries n’a renvoyé de données lors du dernier cycle de rapport"
  },
  "menu": {
    "supportHistory": "Historique d’assistance",
    "supportHistorySearch": "",
    "connectedAppliances": "Appareils connectés",
    "connectedAppliancesSubtitle": "Surveillez et contrôlez vos appareils intelligents",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Surveillez et contrôlez vos appareils compatibles avec Home Connect",
    "appTutorial1": "Vous pouvez vous référer à tous les tutoriels du système à tout moment en naviguant vers la rubrique",
    "appTutorial2": "Connaître votre système ",
    "appTutorial": "Connaître votre système ",
    "appTutorial3": "sous",
    "appTutorial4": "Système",
    "viewallsystutorial": "Voir tous les tutoriels du système",
    "voiceAssistant": "Assistant vocal",
    "voiceAssistantSubtitle": "Activer le contrôle vocal pour Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Prévisions de production",
    "dryContactLoads": "Charges",
    "generator": "Générateur",
    "generatorDevice": "Générateur",
    "loadControl": "Contrôle de charge",
    "loadControlSubtitle": "Contrôler l’énergie de vos charges",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Avis",
    "newNotices": "Avis",
    "reports": "Rapports",
    "exploreEnphase": "Explorer Enphase",
    "exploreEnphaseNewMenu": "Explorer",
    "advanceSettings": "Paramètres avancés",
    "advanceBatterySettings": "Paramètres avancés",
    "advancedBatterySettings2": "Paramètres Avancés",
    "details": "Détails",
    "detailSite": "DÉTAILS DU SITE",
    "detailsInstaller": "DÉTAILS DE L'INSTALLATEUR",
    "systemDescription": "Système La description",
    "systemStatistics": "Statistiques du système",
    "settings": "Réglages",
    "account": "Compte",
    "support": "Assistance",
    "supportFaq": "FAQs",
    "emergencySupport": "Appelez nous maintenant",
    "contactUs": "Nous contacter",
    "contactSupport": "Nous ecrire",
    "devices": "Périphériques",
    "addStorage": "Ajouter du stockage",
    "devicesOld": "Périphériques",
    "configure": "Configurer",
    "batteryStorage": "Stockage de la batterie",
    "batteryStorageNewMenu": "Batterie",
    "connectivity": "Connectivité",
    "connectGateway": "Connectivité",
    "batteryReserve": "Réserve de batterie",
    "expertModeEdit": "Mode expert",
    "eventsHistory": "Historique des événements",
    "backupHistory": "Historique de la sauvegarde",
    "outageHistory": "l'historique des pannes d'électricité",
    "event": "Événement",
    "events": "Événements",
    "totalEvents": "Total événements",
    "totalBackup": "Secours de batterie",
    "backupDuration": "Durée de la sauvegarde",
    "hours": "heures",
    "minutes": "minutes",
    "siteDetails": "Détails du site",
    "envoy": "Passerelle",
    "liveVitals": "Live Stats",
    "envoyNotReport": "La passerelle ne génère pas de rapport",
    "microInverterNotReporting": "Les micro-onduleurs ne génèrent pas de rapport",
    "enpowerNotReporting": "Le contrôleur du système ne génère pas de rapport",
    "enchargeNotReporting": "La batterie ne génère pas de rapport",
    "enchargeError": "Erreur de la batterie",
    "enpowerError": "Erreur du contrôleur du système",
    "microinverters": "Micro-onduleurs",
    "stringInverters": "String Inverter",
    "storage": "Batterie",
    "reconnectToEnvoy": "Connectivité",
    "configureWiFi": "Configurez le Wifi",
    "envoyInternetConnection": "Modifier la connectivité internet de la passerelle",
    "enpower": "Contrôleur du système",
    "theme": "Thème",
    "darkmode": "Mode sombre",
    "devmode": "Developer Mode",
    "appUpdate": "Ajouter une mise à jour",
    "wifi": "Type de connexion",
    "feedback": "Commentaire",
    "logout": "Déconnexion",
    "help": "Aide",
    "visitTommorrowForReport": "Veuillez revenir demain. Le cloud d’Enphase n’a pas collecté les données requises pour créer des rapports.",
    "siteid": "ID du site",
    "email_report": "Envoie du rapport par email",
    "will_send": "Sera envoyé à",
    "batterySubtitle": "Optimisez votre batterie en fonction de l utilisation et du tarif",
    "batteryEmeaSubtitle": "Optimisez votre batterie en fonction de l utilisation",
    "connectivitySubtitle": "Modifiez la connectivité internet de votre passerelle",
    "eventsHistorySubtitle": "Voir le journal des événements clés du système",
    "backupHistorySubtitle": "Voir l’historique des pannes de courant",
    "accountSubtitle": "Détails personnels, La langue, Paramètres de confidentialité",
    "wifiSubtitle": "Bande passante standard, Rapports Données toutes les 15 minutes",
    "liveVitalsSubtitle": "Voir les fonctions vitales du système en direct",
    "themeSubtitleOn": "Le mode sombre est activé",
    "themeSubtitle": "Le mode sombre est désactivé",
    "devmodeSubtitle": "Options du mode développeur",
    "appUpdateSubtitle": "Notes de version pour les dernières mises à jour et le journal des changements",
    "appUpdateSuccessSubtitle": "L’application est à jour",
    "requestReplacement": "Demander un remplacement",
    "changeShippingAddress": "Changer l’adresse d’expédition",
    "tariffEditor": "Tarifaire de l'électricité",
    "tariffEditorNewMenu": "Tarifaire de l'électricité",
    "currencyConversion": "Équivalent en devise",
    "currencyConversionNewMenu": "Devise",
    "currencySubtitle": "Convertit les données d’énergie en taux de devise équivalents",
    "showCurrency": "Montrer l’équivalent en devise",
    "showCurrencySubtitle": "Activer pour montrer le widget de conversion",
    "passwordReset": "Mot de passe réinitialisé",
    "tariffAdded": "Voir/Modifier la structure tarifaire de l’électricité de votre réseau public",
    "showCurrencySubtitleOff": "Désactiver pour afficher le widget de devise",
    "tariffNotAdded": "La structure tarifaire de l’électricité n’a pas été ajoutée",
    "enlightenManager": "Afficher dans Enlighten Manager",
    "sgipIncentive": "Incitation au stockage (SGIP)",
    "gridServices": "Grid Services",
    "enphaseHome": "Vous venez d’emménager dans une maison qui a un système Enphase",
    "systemAccess": "Tout est installé, mais vous avez besoin d’un accès au système",
    "woSiteSystemAccess": "Accès système",
    "enphaseProducts": "Pour en savoir plus sur les produits Enphase",
    "enphaseTeam": "Obtenir de l’aide de l’équipe Enphase",
    "gridSwitch": "Contrôle du réseau",
    "onGrid": "Réseau On",
    "chatWithUs": "Discute avec nous",
    "referFriends": "Parrainer des amis",
    "referralTnC": "Conditions générales",
    "hello": "Bonjour",
    "homeControls": "Home Controls",
    "systemDetails": "Système",
    "pesDetails": "System",
    "community": "Communauté",
    "settingsMenu": "Réglages",
    "enphaseStore": "Enphase Store",
    "upgrades": "Upgrades",
    "services": "Services",
    "generatorSubtitle2": "Configurez votre générateur en fonction de profils intelligents",
    "devicesSubtitle": "Voir tous les appareils et leur statut",
    "siteDetailsSubtitle": "Voir les détails du site et de l’installateur",
    "reportsSubtitle": "Générer et envoyer des rapports",
    "appSettings": "Paramètres de l'application",
    "accountSettings": "Paramètres du compte",
    "addStorageSubtitle": "Ajouter du stockage pour éviter les pannes d’électricité",
    "addSolarPanels": "Ajouter des panneaux solaires",
    "addSolarPanelsSubtitle": "Augmenter votre autoconsommation",
    "sgipIncentiveSubtitle": "Demander une prime SGIP",
    "gridServicesSubtitle": "Gagnez des avantages en aidant le réseau avec IQ Battery.",
    "incentives": "Primes",
    "accountMenu": "Compte",
    "myInformation": "Mon information",
    "myNotificationPreferences": "Mes notifications",
    "myPrivacy": "Ma vie privée",
    "myAccessControl": "Mon contrôle d'accès",
    "myInformationSubtitle": "Mettre à jour les détails personnels et système",
    "myNotificationPreferencesSubtitle": "Gérer mes notifications",
    "myPrivacySubtitle": "Contrôlez la manière dont Enphase utilise les informations système",
    "myAccessControlSubtitle": "Gérer l'accès aux données système",
    "systemSettings": "Les paramètres du système",
    "deviceSettings": "Paramètres de l’appareil",
    "wirelessRangeExtender": "Répéteur sans fil",
    "cacheAction": "Effacer le cache local",
    "cacheResult": "Données énergétiques du navigateur effacées",
    "noActiveNotices": "Il n'y a pas d'avis actifs pour vous",
    "appInfo": "Informations relatives à l’application",
    "whatsNew": "Nouveautés",
    "privacyPolicy": "Politique de confidentialité",
    "tos": "Conditions de service",
    "rateUs": "Notez-nous",
    "gridToggle": {
      "infoPopupTitle": "Système de secours de la lumière du soleil",
      "infoPopupContentP1": "Votre système est un système de secours de la lumière du soleil et le passage en mode Déconnecté du réseau n’est pas recommandé en dehors de la période d’ensoleillement",
      "pIt1": "Lorsque le système passe en mode Déconnecté du réseau, les charges non essentielles sont déconnectées de l’alimentation.",
      "pIt2": "Passer en mode Déconnecté du réseau n’est possible que pendant les heures où la mise sous tension des charges essentielles est programmée dans %{scheduledMode}.",
      "pIt3": "Votre système peut s’arrêter en mode Déconnecté du réseau si l’ensoleillement est insuffisant.",
      "scheduledMode​": "Mode programmé​",
      "infoPopupContentP2": "Lorsque le système passe en mode Déconnecté du réseau, les charges sont déconnectées de la source d’énergie, sauf celles qui sont essentielles. Le passage en mode Déconnecté du réseau n’est pas autorisé en dehors des heures prévues. Votre système peut s’arrêter en mode Déconnecté du réseau si l’ensoleillement est insuffisant."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Get to know your device",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Prenez votre énergie avec vous. Sécurité et puissance de l’énergie à emporter.",
      "enphasePESConnectDevice": "Connecter un appareil",
      "enphasePESLearnMore": "En savoir plus",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Register your device",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Make sure your phone’s Bluetooth is turned on.",
      "registerStep1": "Se connecter / s’inscrire à un compte Enphase",
      "registerStep2": "Pair your device and phone via Bluetooth​",
      "registerStep3": "Give your device a name​",
      "registerStep4": "Connect it to the Wi-Fi network​",
      "register": "Register",
      "start": "Start",
      "later": "Later",
      "fserialNumber": "Enter Serial No.",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Name Your Device",
      "enterBoxName": "Device Name",
      "connectToWiFi": "Connect your device to Wi%{nbh}Fi",
      "connectToWiFiNotice": "Select your preferred Wi-Fi network and enter password.",
      "takeFewMinutes": "This may take a few minutes",
      "connectingToWifi": "Connecting to Wi-Fi",
      "pleaseContactSupport": "Please contact support for help",
      "unableToCompleteConnect": "Unable to complete the connect",
      "incomplete": "Incomplete",
      "congratulations": "Congratulations!",
      "incorrectPasswordTryAgain": "Incorrect password. Please try again",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "is registered",
      "startMonitoring": "Start Monitoring",
      "turnOnBluetoothOnNotice": "Your mobile bluetooth seems to be switched off. Please turn it on to connect to Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy Systems Around",
      "noOjasDevicesFound": "No Portable Energy System found",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Incorrect Code",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Capturing Device Details",
      "capturedDeviceDetails": "Device details captured",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Registration Error",
      "registrationErrorNotice": "Please retry registration. If problem persist, ",
      "deviceAlreadyRegistered": "Device already registered",
      "deviceAlreadyRegisteredNotice": "Ce système d’énergie portable est déjà enregistré sur un autre compte Enphase.",
      "proceed": "Proceed",
      "rename": "Rename",
      "nameAlreadyExist": "Name already exist",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Bluetooth connection eshtablished!",
      "enter4DigitCode": "Enter 4 digit code",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Resend code",
      "connWithOJASBLE": "Connect with Portable Energy System via Bluetooth",
      "noBLEDevicesFound": "No bluetooth devices found",
      "backupTime": "Backup Time",
      "timeToCharge": "Time to Charge",
      "powerSaving": "Power Saving",
      "poweredOn": "Powered On",
      "powerOn": "Power On",
      "powerOff": "Power Off",
      "close": "Fermer",
      "powerSavingHeader": "Device is Power Saving",
      "powerOnHeader": "Device is Powered On",
      "powerSavingSubHeader": "(AC output disabled)",
      "powerSavingContent": "You can remotely power on and enable AC output or shut down the device and disable all the input and output power supply.",
      "powerOnContent": "You can remotely shut down the device and disable all the input and output power supply.",
      "shuttingDown": "Shutting down in",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "L’appareil n’est pas connecté à l’application Enphase !",
        "1_description": "Please ensure your device is turned on and connected to Wi-Fi. If you are nearby your device, you can pair your phone with the device using Bluetooth.",
        "1_action": "Connect using Bluetooth",
        "3_title": "Bluetooth not supported!",
        "3_description": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
        "4_title": "Turn On Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Scanning for Bluetooth devices...",
        "7_title": "Bluetooth devices",
        "8_title_success": "No bluetooth devices found.",
        "8_title_error": "Problem persisted while scanning.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Eshtablish Bluetooth connection...",
        "10_title": "Enter proof of possession PIN for",
        "10_subTitle": "Proof of Possession PIN",
        "11_title": "Bluetooth connection established!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " is successfully eshtablished.",
        "12_title": "Bluetooth Not-Connected.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " is failed, Please try again.",
        "13_title": "Searching for Wi-Fi networks...",
        "14_title": "Connect PES to Wi-Fi",
        "14_description": "Select your preferred Wi-Fi network and enter password.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "No Wi-Fi network found.",
        "15_title_error": "Problem persisted while scanning.",
        "15_description": "No Wi-Fi network found. Reboot your Wi-Fi router and try again.",
        "18_title_1": "Sending Wi-Fi credentials",
        "18_title_2": "Applying Wi-Fi connection",
        "18_description": "provisioned successfully,",
        "19_title": "Incomplete!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Device ID",
      "ojasSettings": {
        "profile": "Profils",
        "acPorts": "Ports AC",
        "dcPorts": "Ports DC",
        "on": "Allumé",
        "off": "Éteint",
        "brightnesSettings": {
          "brightness": "Luminosité",
          "customBrightness": "Luminosité personnalisée",
          "auto": "Réglage automatique de la luminosité"
        },
        "lightSettings": {
          "light": "Clair",
          "on": "Toujours allumé",
          "off": "Toujours éteint",
          "auto": "Automatique",
          "onMsg": "Reste allumé",
          "autoMsg": "S’allume lorsque quelqu’un est à proximité",
          "offMsg": "Reste éteint"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Sous-tension",
          "powerOff": "Hors tension",
          "powerSave": "Économie d’énergie"
        },
        "ojasModes": {
          "on": "Tous les ports de sortie AC et DC sont allumés. Gardez l’appareil dans ce mode si vos outils ou appareils sont branchés sur le port AC.",
          "save": "Seuls les ports DC sont allumés et prêts à alimenter les appareils électroniques. Ce mode fait économiser de l’énergie car les ports AC sont désactivés.",
          "off": "Toutes les sources d’alimentation d’entrée et de sortie seront éteintes."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Économies",
    "appTutorialPage": {
      'all-topics-empty': 'Aucun sujet disponible',
      'videos-empty': 'Aucune vidéo disponible',
      'articles-empty': 'Aucun article disponible',
      'noResults': "Aucun r\xE9sultat pour \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Environnement",
    "label": "Impact environnemental",
    "rightText": "Source : epa.gov",
    "equivalent": "Équivalent",
    "planted": "PLANTÉ(S)",
    "carbon_offset": "COMPENSATION CARBONE",
    "charged": "CHARGÉ",
    "trees": {
      "zero": "arbres",
      "one": "arbre",
      "other": "arbres"
    },
    "phone": {
      "one": "téléphoner",
      "other": "téléphones"
    },
    "tonne": {
      "one": "tonne",
      "other": "tonnes"
    },
    "lb": {
      "one": "livre",
      "other": "livres"
    },
    "ton": {
      "one": "tonne",
      "other": "tonnes"
    }
  },
  "connectionType": {
    "wifi": "Wi-Fi",
    "cellular": "Modem cellulaire",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Rapporte les données toutes les 15 min",
    "reportsAt6Hrs": "Rapporte les données toutes les 6 h",
    "idle": "Inactif",
    "notAvailable": "Non disponible",
    "configureWiFiSettings": "Configurer les paramètres sans fil",
    "configureWiFiSettings2": "Configurer",
    "switchToWiFi": "Passez sur le Wi-Fi",
    "connectToWiFi": "Se connecter au Wi-Fi"
  },
  "details": {
    "connection_type": "Type de connexion",
    "description": "Description du système",
    "installer": "Installé par",
    "maintainer": "Mainteneur système",
    "micros": {
      "one": "Micro-onduleur",
      "other": "Micro-onduleurs"
    },
    "acbs": {
      "one": "Batterie",
      "other": "Batteries"
    },
    "arrays": {
      "one": "Champ PV",
      "other": "Champs PV"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% de plus que la veille à la même période",
    "less_yesterday": "% de moins que la veille à la même période",
    "same_yesterday": "À peu près identique à la veille à la même période",
    "more_last_year": "% de plus que l’année dernière à la même période",
    "less_last_year": "% de moins que l’année dernière à la même période",
    "same_last_year": "À peu près identique à l’année dernière à la même période",
    "more_yesterday_prev": "% de plus qu'à cette heure la veille",
    "less_yesterday_prev": "% de moins qu'à cette heure la veille",
    "same_yesterday_prev": "À peu près la même heure que la veille",
    "more_last_year_prev": "% de plus qu'à cette époque l'année précédente",
    "less_last_year_prev": "% de moins qu'à cette époque l'année précédente",
    "same_last_year_prev": "À peu près le même que celui de l'année dernière",
    "system": "Système",
    "emptyArray": "Pas de disposition du champ PV disponible",
    "storageArray": "Station de stockage",
    "solarArray": "Panneau solaire",
    "contactInstForpersonalizedLayout": "Contactez votre installateur pour obtenir un aperçu personnalisé de votre tableau de stockage.",
    "cntcInstPopP1": "Le tableau de stockage illustre les unités de stockage installées chez vous ainsi que leur niveau de charge.",
    "cntcInstPopP2": "Veuillez contacter votre installateur pour concevoir le tableau de stockage dans l’application Installer ToolKit ou l’application Enlighten Manager afin d’obtenir une vue plus personnalisée."
  },
  "support": {
    "enphase": "Assistance Enphase",
    "enphaseLink": "Assistance Enphase",
    "maintainer": "Assistance et maintenance système",
    "maintainerLink": "Contacter le mainteneur",
    "contactEnphase": "Contacter Enphase",
    "enphaseSupport": "Assistance Enphase",
    "ensembleSupport": "Appel Ensemble Support",
    "writeToUs": "Nous ecrire",
    "visitSupport": "Visiter le support",
    "talkToUs": "Contactez nous",
    "talkToUsAnytime": "Parlez-nous à tout moment",
    "customerSupport24by7": "Assistance clientèle 24/7",
    "needMoreHelpTitle": "Besoin d’aide supplémentaire",
    "productionIssue": "Problème de production",
    "microinvertersNotReporting": "Les micro-inverseurs ne génèrent pas de rapport",
    "envoyNotReporting": "Le système ou la passerelle ne génère pas de rapport",
    "productionDifference": "Différence de production par panneau",
    "needHelpTitle": "Avez-vous besoin d’aide si",
    "contactUs": "Nous contacter",
    "askEnphaseCommunity": "Demandez à Enphase Community",
    "browseTopics": "Parcourir toutes les rubriques d’aide",
    "chatWithUs": "Discute avec nous",
    "helpTopics": "Rubriques d’aide",
    "brwsAllFaqs": "Parcourir toutes les FAQ",
    "askEnphaseCommunitySubtitle": "Contactez d’autres clients Enphase autour de vous.",
    "systemOwnerGuide": "Consulter le guide du propriétaire du système",
    "faq": {
      "usingManualOverride": "Utiliser la commande manuelle",
      "understandingEnpower": "Comprendre IQ System Controller",
      "understandingEncharge": "Comprendre IQ Battery",
      "understandIQCombiner": "Comprendre l’IQ Combiner, la passerelle, le kit de communication et le modem cellulaire",
      "stormGaurdFeatureDetails": "Détails de la fonction Protection contre les orages",
      "settingElectricityRateStructure": "Définition de la structure tarifaire de l’électricité",
      "recoverShutdownLL": "Restauration après arrêt dû aux charges importantes",
      "recoverShutdownCF": "Restauration après arrêt dû à la défaillance des communications",
      "recoverShutdownBD": "Récupération après un arrêt dû à un épuisement de la batterie",
      "PowerHomeInBCK": "Alimenter vos charges domestiques en mode secours",
      "partialHomeBCK": "Configuration du mode secours partiel",
      "monitorUrSys": "Surveiller votre système",
      "mngLgApplianceBck": "Gérer les gros appareils en mode secours",
      "incentivesAvlbTou": "Avantages disponibles",
      "grdTrnxToOffGrd": "Transition réseau à hors réseau",
      "allHomeBck": "Configuration du mode secours complet",
      "envLEDstatus": "État des voyants de la passerelle",
      "dsgnUrSys": "Concevoir votre système",
      "cntctCustSupp": "Contacter l’assistance clientèle",
      "batSmrtPrfSel": "Sélection du profil intelligent de la batterie",
      "accsEnchrgDcswtch": "Accès au commutateur CC de la batterie",
      "mcrInvNtReprt": "Le micro-onduleur n’envoie pas de rapport",
      "sysEnvNtReprt": "La passerelle ne génère pas de rapport",
      "hwUrSysWrk": "Comment votre système fonctionne",
      "enchrLedStatus": "État des voyants de la batterie",
      "noPwNebDo": "Ma maison n'a pas d'électricité mais mes voisins en ont",
      "consBatDurGridOut": "Économisez la batterie lors d'une panne de courant",
      "emgSupCallSteps": "Choisissez 2 pour le service client et 1 pour le propriétaire du système. Sélectionnez 2 dans le sous-menu des systèmes de stockage.",
      "preLoginCallSteps": "Veuillez sélectionner 2 pour l'assistance client ou 4 pour les ventes.",
      "sysProdIssue": "Problème de production du système",
      "diffInPerPanProd": "Différence de production par panneau",
      "installCellModem": "Guide d'installation du modem cellulaire",
      "whatIsEI": "Score d’indépendance énergétique",
      "howEnHomeEngSysWork": "Comment fonctionne le système d'énergie domestique Enphase?",
      "understandEnv": "Comprendre la passerelle",
      "findEnv": "Trouver ma passerelle",
      "envReplaced": "La passerelle a été remplacée",
      "rebootEnv": "Redémarrer ou relancer la passerelle",
      "hwChangeEmail": "Comment changer mon email?",
      "hwResetPasswd": "Comment réinitialiser mon mot de passe?",
      "accessEnvLocalIntf": "Accéder à l’interface locale de la passerelle",
      "envLocIntfLogCred": "Identifiants de connexion de l’interface locale de la passerelle",
      "hwDisbaleNotification": "Comment activer et désactiver les rapports mensuels et autres notifications par e-mail?",
      "MontEngProd": "Suivi de ma production d'énergie",
      "whyNotSeeConsumption": "Pourquoi ne puis-je pas voir ma consommation?",
      "hwMonConsumpt": "Comment surveiller la consommation de mon logement?",
      "calEngUsageWoConsumptionMonitoring": "Calculer ma consommation d'énergie sans suivi de consommation",
      "undersNetEng": "Comprendre l'énergie nette",
      "understTrueUpStmt": "Comprendre une déclaration de True-up",
      "diffPaidENLMvsPerpanelDataaoffering": "Différence entre Enlighten Manager payant et l'offre gratuite de données énergétiques par panneau",
      "blkInPerpanMon": "Panneau noir dans la vue par panneau",
      "gryorBlnkInPerpanMon": "Panneau gris (vierge) dans la vue par panneau",
      "hwToMovePnl": "Comment déplacer un panneau?",
      "hwfindInst": "Comment trouver un nouvel installateur?",
      "whtdoIfonePanelNotreproduc": "Que dois-je faire si l'un des panneaux est en sous-production ou ne produit pas?",
      "haveaSelfPoweredHome": "Qu’est-ce que cela signifie d’avoir une maison auto-alimentée ?",
      "yourSystemPaysForItself": "Combien de temps avant que votre système soit rentabilisé ?",
      "enphaseSystemsAreSafe": "Pourquoi les systèmes Enphase sont-ils sûrs ?"
    },
    "webBackButton": "Retour",
    "supportHistory": "Historique d’assistance"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Ajouter un véhicule électrique",
    "addevSub": "Faites-nous savoir si vous utilisez votre système Enphase pour charger votre VE afin que nous puissions vous fournir des informations et vous recommander des délais optimaux pour charger efficacement votre véhicule.",
    "haveEv": "J’ai un VE.",
    "qbrand": "Quelle est la marque de votre VE ?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "Quel est le nom du modèle de votre VE ?",
    "diffcharger": "Je charge mon VE à mon domicile en utilisant un chargeur d’une entreprise différente",
    "qcharger": "Quelle est la marque de votre chargeur ?",
    "qcapacity": "Quelle est la capacité de batterie de votre EV (in kWh) ?",
    "notcompulsory": "*cette question n’est pas obligatoire. Vous pouvez l’ignorer si vous ne savez pas.",
    "qtime": "Quand chargez-vous votre véhicule ?",
    "morning": "Matin",
    "afternoon": "Après-midi",
    "evening": "Soir",
    "night": "Pendant la nuit",
    "other": "Autre (veuillez préciser)",
    "qmiles": "Combien de kilomètres parcourez-vous généralement en voiture par jour ?",
    "brand": "Détails de la marque",
    "tech": "Détails technique",
    "operational": "Détails opérationnels",
    "ev": "Véhicule électrique :",
    "suggsch": "Calendrier suggéré",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Retirer le véhicule électrique",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Activer Storm Guard",
    "stormGuardEnablePopUpFooter": "Souhaitez-vous activer Storm Guard?",
    "stormGuardDisablePopUpHeader": "Désactiver Storm Guard",
    "stormGuardDisablePopUpFooter": "Souhaitez-vous tout de même désactiver Storm Guard?",
    "backupTime": "Temps de sauvegarde",
    "encharge_battery": "Sélectionnez un profil intelligent pour contrôler votre batterie",
    "encharge_battery_emea": "Profil intelligent pour contrôler votre batterie",
    "savings": "Mode Économie",
    "expert": "Mode expert",
    "self-consumption": "Autoconsommation",
    "battery_bkup": "Totalité en alimentation de secours",
    "savings_text": "Utiliser si vos coûts en énergie varient au cours de la journée. La batterie est chargée pendant les heures creuses et utilisée pendant les heures pleines et après le coucher du soleil.",
    "savings_mode_notSet": "Maximise vos économies en fonction des tarifs de l’électricité",
    "savings_mode_dc_tou": "Les systèmes photovoltaïques et les batteries sont utilisés pendant les heures pleines pour réduire au maximum l’importation d’électricité depuis le réseau.",
    "savings_mode_dc_all_day": "Veuillez définir votre tarif d’importation d’électricité comme NEM pour activer ce mode",
    "viewElectricityRate": "Afficher les tarifs d’électricité",
    "optForDC": "Optimisé pour économiser sur les frais de demande",
    "optForIncExport": "Optimisé pour augmenter l’exportation",
    "consumption_text": "Utiliser l'énergie solaire stockée pour alimenter votre habitation après le coucher du soleil. La batterie est utilisée lorsque l'énergie solaire n'est pas disponible.",
    "consumption_text_pv_yield": "Chargez la batterie pendant les heures de pointe de production pour optimiser la production photovoltaïque. La batterie est utilisée lorsque l'énergie solaire n'est pas disponible.",
    "bkup_text": "100 % de la batterie est réservée à l'alimentation de secours.",
    "reserve": "Réserve",
    "optimization": "Optimisation basée sur",
    "utility_rates": "Tarif des services publics",
    "increase_consumtion": "Augmenter L'autoconsommation à",
    "max_consumption": "Maximiser L'indépendance Énergétique",
    "optimize_pv_production": "Optimiser la production photovoltaïque",
    "activate": "Activer",
    "active": "Actif",
    "save": "Enregistrer",
    "edit": "MODIFIER",
    "error": "Impossible d'enregistrer les paramètres de stockage.",
    "requestTakingLonger": "La demande est plus longue que prévu. Revérifiez plus tard",
    "batterySettingsTakingLonger": "La mise à jour des paramètres de la batterie est plus longue que prévu. Revérifiez plus tard",
    "completed": "Les paramètres de la batterie ont bien été mis à jour.",
    "completedAdvance": "Les paramètres avancés de la batterie ont bien été mis à jour.",
    "requestPending": "Demande en attente. En attente de confirmation de la part de la passerelle. Revérifiez plus tard.",
    "editRequest": "Vous avez une demande active. Veuillez attendre la confirmation ou annuler cette demande pour continuer la sélection.",
    "editRequestVls": "Vous avez une requête active dans les Paramètres avancés de la batterie. Veuillez attendre la confirmation ou annuler cette demande pour continuer la sélection.",
    "cancelRequest": "Votre demande a été annulée.",
    "updatedSuccesfully": "Mise à jour réussie",
    "pendingRequestText": "Demande en attente",
    "cancelRequestText": "Annuler la demande",
    "pendingText": "En attente",
    "processingText": "Traitement",
    "battery_reserve": "de l'énergie stockée sera réservée à l'alimentation de secours",
    "cancelFailed": "Impossible d'annuler la tâche.",
    "noPendingTask": "Le système n'a pas de tâche en attente à annuler.",
    "noEncharges": "Le système n’a pas de batteries",
    "severeWeatherText": "Surveillance des phénomènes météorologiques violents",
    "disabled": "Désactivé",
    "enabled": "Activé",
    "weatherWatchDescription": "Contourne votre profil de batterie pour passer en mode secours complet lorsqu’une alerte de conditions météorologiques extrêmes est émise pour votre localité.",
    "disabledModeInfo": "Lorsqu’il est activé, Enphase communique avec le {%s} pour détecter les alertes d’événements météorologiques violents et configure votre profil de batterie en mode sauvegarde complète pour fournir une sauvegarde pendant l’événement. Une fois l’événement passé, le profil de batterie revient à son réglage précédent.",
    "enabledModeInfo": "Enphase communique avec le {%s} pour détecter les alertes de phénomènes météorologiques violents et met votre profil de batterie en mode sauvegarde complète. Après l’événement, le profil de batterie revient à son réglage précédent.",
    "activeModeInfo": "Enphase a détecté une alerte de phénomène météorologique violent en provenance de {%s} et votre profil de batterie est réglé sur le mode sauvegarde complète. Une fois l’événement passé, le profil de batterie reviendra à son réglage précédent.",
    "stormGuardModeInfo": "Lorsque %{status}, la fonction Protection contre les orages surveille les alertes de conditions météorologiques extrêmes émises par %{nws}. Elle contourne votre profil de batterie pour passer en mode ‘Totalité en alimentation de secours’ si une alerte est émise pour votre localité. Ceci permet à l’ensemble de la capacité de votre batterie d’être réservée à l’utilisation pendant une possible panne du réseau.%{nl}Si une alerte est émise pour votre localité, alors ‘Storm Alert: On’ est affiché sous ‘profil de batterie’ sur la page Statut et sur la page Statut en direct.%{nl}Après la fin de l’événement, le profil de la batterie reviendra à ses paramètres précédents.",
    "editActiveWeatherAlert": "La Surveillance des phénomènes météorologiques violents est active. Veuillez attendre que le phénomène soit passé (recommandé) ou désactiver la surveillance des phénomènes météorologiques violents pour continuer la sélection.",
    "enabledToActiveAlert": "Enphase a détecté une alerte de phénomène météorologique violent provenant du service météorologique national et votre profil de batterie sera réglé sur le mode sauvegarde complète. Une fois l’événement passé, le profil de batterie reviendra à son réglage précédent.",
    "activeToEnabledAlert": "Le phénomène météorologique violent est terminé et votre profil de batterie est défini sur son paramètre précédent.",
    "okayText": "OK, j’ai compris !",
    "disclaimerText": "La fonction Protection contre les orages utilise les informations recueillies de la National Oceanic and Atmospheric Administration [Administration nationale des affaires océaniques et atmosphériques] des États-Unis ou du National Weather Service, telles que (sans s’y limiter) les alertes météo, dont les informations font partie du domaine publique et ne sont pas soumises à la protection du droit d’auteur. Enphase ne revendique pas la propriété ou le contrôle de ces informations. Vous acceptez expressément que vous utilisez cette fonctionnalité à vos propres risques. Et vous assumez pleinement les risques liés à l’activation de cette fonctionnalité et à son utilisation subséquente. Enphase fournit les informations via la fonction Protection contre les orages « telles quelles » et ne reconnaît aucune garantie, expresse ou implicite, y compris (sans s’y limiter) les garanties implicites de qualité marchande et d’adéquation à une utilisation spécifique. Enphase ne sera en aucun cas responsable, envers vous ou un tiers, pour tous dommages directs, indirects, accessoires, consécutifs, spéciaux ou exemplaires ou pour toute perte de profits résultant de l’utilisation ou de la mauvaise utilisation de ces données.",
    "disclaimer": "Clause de non-responsabilité",
    "agreeText": "Accepter & continuer",
    "disagreeText": "Refuser",
    "nationalWeather": "National Weather Service (NWS)",
    "dataNotAvailable": "NA",
    "errorTitle": "Erreur",
    "errorCode": "Code d’erreur",
    "thresholdError": "Reporting Error",
    "PopupError": "Votre batterie S.NO",
    "thresholdPopupError": "Aucun rapport généré lors du dernier cycle de rapport ? Le % de stockage global exclut donc le % de stockage de cette batterie. La batterie devrait commencer à générer des rapports lors du prochain cycle de rapport. Contactez l’assistance à la clientèle si le problème persiste.",
    "errorPopup1": "présente un problème (Description de l’erreur :",
    "errorPopup2": ", Code d’erreur :",
    "errorPopup3": "). Cet événement d’erreur ne permet pas de considérer le % de stockage renvoyé de cette batterie comme fiable. Le pourcentage de stockage global mentionné ci-dessus exclut donc le pourcentage de stockage de cette batterie. Contactez l’assistance à la clientèle si le problème persiste.",
    "contactSupport": "Contacter l’assistance",
    "errorSubmitButton": "D’accord, j’ai compris",
    "microinvertorError": "Le micro-onduleur de la batterie n’est pas actif",
    "microinvertorsError": "Les micro-onduleurs de la batterie ne sont pas actifs",
    "touAlert": "Le mode économie ne fonctionne que si votre taux d’importation d’électricité varie en fonction de votre utilisation. Veuillez mettre à jour votre taux d’importation d’électricité pour activer ce mode.",
    "touAlert2": "Veuillez définir votre taux d’importation d’électricité comme ToU et votre plan tarifaire d’exportation comme NEM pour activer le mode économie.%{nl}Le mode Économies ne fonctionne que si vous disposez d’un Compteur d'énergie nette (NEM) et que votre taux d’électricité varie en fonction du temps d’utilisation (ToU).",
    "touAlert3": "Veuillez définir votre taux d’importation d’électricité comme ToU pour activer le mode Économies.",
    "touAlert4": "Veuillez configurer votre plan d’exportation d’électricité pour activer le mode Économies.",
    "updateElectricityRate": "Mettre à jour le taux d’électricité",
    "batteryChangeAlert": "Votre profil de batterie a été modifié en Mode de consommation autonome puisque le mode économie ne fonctionne que si le taux d’importation d’électricité varie en fonction de votre utilisation.",
    "batteryChangeAlert2": "Votre profil de batterie a été modifié en mode autoconsommation, car le mode Économies ne fonctionne que si vous disposez d’un Compteur d’énergie nette (NEM) et que votre tarif d’électricité varie en fonction du temps d’utilisation (ToU).",
    "viewDetails": "Voir les détails",
    "ok": "Ok",
    "systemRequest": "Les demandes générées par le système ne peuvent être annulées.",
    "featureDetailsButton": "Détails de la fonctionnalité Storm Guard",
    "stormGuardEnablePopUp": "L’activation de Storm Guard permet de réserver toute la capacité de votre batterie pour qu’elle puisse être utilisée lors d’une panne de réseau potentielle, en mettant le profil de la batterie sur « Alimentation de secours totale » en cas d’alertes pour intempéries.",
    "stormGuardDisablePopUp": "Il est déconseillé de désactiver Storm Guard. En cas d’alertes pour intempéries, il vous permet d’être toujours protégé contre les pannes de réseau liées aux intempéries.",
    "batterySmartProfile": {
      "title": "Sélection du profil intelligent de la batterie",
      "description": "Découvrez comment choisir le bon profil pour votre système de batterie",
      "viewDetails": "Voir les détails"
    },
    "reserveDisclaimer": "La réserve de la batterie ne peut être définie en dessous de  %{minSoc}%. Un minimum de  %{minSoc}% d’énergie est stocké dans la batterie pour alimenter vos charges domestiques critiques pendant une panne de réseau.",
    "eIpopDesc": "%{enabled}: Votre batterie se décharge pour économiser de l'argent aux heures de pointe lorsque les prix de l'électricité sont élevés. Une fois cela fait, la priorité sera donnée à l'indépendance énergétique. Cela augmente votre autonomie énergétique jusqu'à ce que vous atteigniez la charge de charge de la batterie. Votre batterie sera chargée d'énergie solaire le matin pour se préparer à la prochaine période de pointe.%{nl}%{disabled}: Votre batterie ne se déchargera que pendant les heures de pointe lorsque le tarif d'électricité est élevé. À d'autres moments, votre batterie est inactive ou est chargée par l'énergie solaire le matin pour vous préparer à la prochaine période de pointe.",
    "errActiveCostSave": "Veuillez activer le mode Économies pour utiliser cette fonctionnalité",
    "eiDescreption": "Indépendance énergétique après les heures de pointe",
    "advSetting": {
      "cfg": {
        "title": "Charger la batterie depuis le réseau",
        "descrDisable": "Votre batterie se charge à partir de Solar.",
        "descrEnabled": "La batterie est chargée à l'énergie solaire. Il peut également être rechargé sur secteur lorsque la batterie est en mode secours complet ou lorsque la charge de la batterie descend en dessous de la capacité de réserve en mode économie ou autoconsommation.",
        "descrEnabledFR": "Votre batterie se chargera à partir du réseau dans l’intervalle programmé. Elle ne se déchargera pas pendant cette période.",
        "popUpDescrFR": "%{enabled}: Votre batterie se chargera à partir du réseau dans l’intervalle programmé. Elle ne se déchargera pas pendant cette période. %{nl}%{disabled}: Votre batterie se charge grâce à l’énergie solaire.",
        "popUpDescr": "%{enabled}: La batterie est chargée à l'énergie solaire. Il peut également être rechargé sur secteur lorsque la batterie est en mode secours complet ou lorsque la charge de la batterie descend en dessous de la capacité de réserve en mode économie ou autoconsommation.%{nl}%{disabled}: Votre batterie se charge à partir de Solar.",
        "disclaimer": "L'utilisation d'une source d'énergie non renouvelable pour charger votre système de stockage Enphase peut affecter votre éligibilité à utiliser l'ITC. Veuillez contacter votre conseiller fiscal pour plus d'informations.",
        "dlgTitle": "Charger à partir du réseau ?",
        "dlgInfo": "Une fois désactivée, votre batterie se chargera à partir du réseau dans l’intervalle programmé. Elle ne se déchargera pas pendant cette période. Veuillez vérifier les réglementations du service public avant d’activer cette option.",
        "selfDeclrFR": "JJe comprends que la recharge du réseau peut être contraire aux réglementations des services publics.",
        "selectSchedule": "Sélectionnez le calendrier pour charger votre batterie à partir du réseau.",
        "titleFR": "Programmer le chargement à partir du réseau",
        "saveSch": "Enregistrer le calendrier",
        "chargeSch": "Calendrier du chargement",
        "selfDeclr": "Je comprends que mon admissibilité au crédit d'impôt à l'investissement peut être affectée.​​",
        "disclaimer_itk": "L'utilisation d'une source d'énergie non renouvelable pour modifier le système de stockage Enphase peut affecter l'admissibilité à une demande de CTI. Consulter le propriétaire pour son approbation.",
        "selfDeclr_itk": "Le propriétaire reconnaît que la capacité de demander le crédit d'impôt à l'investissement peut être compromise.",
        "activeStormAlert": "L’alerte orages est activée pour votre système. Attendez la fin de l’alerte pour terminer la mise à jour de ce paramètre."
      }
    },
    "exM": {
      "title": "Mode expert",
      "subTitle1": "Programmer les profils de batterie",
      "subTitle2": "Profils de batterie programmés",
      "schedule": "Programmer",
      "tariffNotSetDlgtitle": "Tarif d’électricité non défini",
      "tariffNotSetDlgContent": "Veuillez régler votre tarif d’électricité pour activer le mode d’économie.%{nl}Enphase a besoin des détails de votre tarif pour déterminer le meilleur programme pour votre batterie.",
      "setRate": "Définir le tarif",
      "tariffUpdateDlgtitle": "Mettre à jour le tarif d’électricité",
      "tariffUpdateDlgContent": "Le mode Économies ne fonctionne que si vous avez une facturation d’énergie nette (NEM, Net Energy Metering) et si votre tarif d’électricité varie avec les heures d’utilisation (ToU, Time-of-Use).",
      "updateRate": "Mettre à jour le tarif",
      "setNemDlgTitle": "Electricity Export Rate Not Set",
      "setNemDlgContent": "Veuillez définir votre tarif d’importation d’électricité comme NEM pour activer ce mode.",
      "setNemCta": "Définir comme NEM",
      "preview": "Aperçu",
      "addBatProfile": "Ajouter un profil de batterie",
      "pViewPop": {
        "l1": "Le graphique représente les profils de batterie programmés pour une période de 24 heures.",
        "l2": "La réserve de la batterie peut être appliquée pour les modes Économies et Autoconsommation uniquement. En mode Sauvegarde complète, votre réserve de batterie sera de 100%.",
        "l3": "Maximise votre indépendance énergétique",
        "l4": "Maximise vos économies en fonction des tarifs de l’électricité",
        "l5": "Conserve 100 % de l’énergie de la batterie en secours",
        "batteryProfiles": "Profils de batterie"
      },
      "batReserveDisclaimer": "La réserve de la batterie peut être appliquée pour les modes Économies et Autoconsommation uniquement. En mode Sauvegarde complète, votre réserve de batterie sera de 100 %."
    },
    "prfAssist": {
      "t0": "Déjà dans le profil recommandé",
      "t1": "Nous vous recommandons",
      "t2": "Mode Économie avec faible réserve de batterie et indépendance énergétique activée.",
      "t3": "Mode Économie avec faible réserve de batterie et indépendance énergétique désactivée.",
      "t4": "Mode Autoconsommation avec faible réserve de batterie.",
      "t5": "Mode Autoconsommation avec réserve de batterie modérée.",
      "t6": "Mode Sauvegarde complète.",
      "t7": "Mode Économie avec réserve de batterie élevée et indépendance énergétique désactivée.",
      "t8": "Mode Autoconsommation avec réserve de batterie élevée.",
      "batResText": "Réserve de batterie entre",
      "learnHowEmea": "En savoir plus sur le profil de la batterie",
      "learnHow": "Comprendre le fonctionnement des profils de batterie",
      "editPref": "Modifier les préférences",
      "c1": "d’économiser de l’argent",
      "c1Sub": "de maximiser les économies sur les factures mensuelles",
      "c2": "de bénéficier de l’indépendance énergétique",
      "c2Sub": "d’alimenter votre maison en énergie tout en faisant un pas vers l’écologie",
      "c3": "Alimentation de secours",
      "c3Sub": "de bénéficier d’une sauvegarde en cas de coupure de courant",
      "p1": "Priorité principale",
      "p2": "Priorité secondaire",
      "optional": "En option",
      "ques": "Le système Enphase doit vous permettre...",
      "priority": "Veuillez glisser-déposer les objectifs dans l’ordre du plus important au moins important.",
      "ftrpTutorialText": "Sélectionnez les cartes et faites-les glisser vers le haut ou le bas selon leur priorité. La première carte en partant du haut représente la plus haute priorité.",
      "updateBatteryProfile": "Mettre à jour le profil de batterie",
      "activatedSavingsMode": "Votre batterie est actuellement en Mode d’économie avec une réserve de %{soc}% et son Indépendance énergétique après les heures pleines est de %{eiStatus}.",
      "activatedSelfConsumptionMode": "Votre batterie est actuellement en Auto-consommation avec une réserve de %{soc}%.",
      "activatedFullBackupMode": "Votre profil de batterie actuel est Alimentation de secours totale.",
      "activatedSavingsModeWithoutSoc": "Votre batterie est actuellement en mode Économies et l’indépendance énergétique après les heures de pointe est %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Votre batterie est actuellement en mode Autoconsommation.",
      "activateProfile": "Voulez-vous activer le profil recommandé?"
    }
  },
  "envoy": {
    "all": "Toutes les passerelles",
    "pvAll": "Tout",
    "dropDwnHelper": "Afficher les données de",
    "envSN": "Numéro de Série Passerelle:",
    "reconnect": "Veuillez reconnecter votre passerelle.",
    "extraContent": "En attendant, si vous êtes près de votre système, vous pouvez vous connecter localement à la passerelle pour voir l’état actuel.",
    "btnText": "Découvrir comment se connecter au Wi-Fi de la passerelle",
    "getHelp": "Reconnectez votre passerelle au réseau Wi-Fi domestique",
    "envoyConfirmation": "Connectez-vous à la passerelle en mode AP pour continuer.",
    "title": "Nous avons constaté que vous utilisez la passerelle Envoy-S ou IQ Gateway, ainsi que le Wi-Fi.",
    "steps": "Suivez les étapes pour connecter la passerelle au réseau Wi-Fi",
    "steps_ap": "Suivez les étapes pour vous connecter au réseau de la passerelle",
    "ap_button": "Appuyez sur le bouton de mode AP",
    "ap_modeDescription": "Appuyez brièvement sur le bouton de menu de la passerelle situé sous l’icône du téléphone (sans le maintenir enfoncé), puis relâchez-le. Cette opération permet d’activer le mode AP sur votre passerelle, ce qui crée un réseau sans fil que vous pouvez connecter à votre téléphone.",
    "disable_data": "Désactiver les données mobiles",
    "disable_dataDescription": "Désactivez les données mobiles (données cellulaires) depuis les paramètres de votre appareil mobile. Allez dans Paramètres > Données mobiles et désactivez-les.",
    "envoy_network": "Se connecter au réseau de la passerelle",
    "envoy_description": "Connectez-vous au réseau de la passerelle à l’aide des paramètres Wi-Fi de votre téléphone. Envoy_029655 est le nom du mini-réseau auquel vous allez vous connecter, « 029655 » correspond aux six derniers chiffres du numéro de série de votre passerelle.",
    "home_wifi": "Connecter la passerelle au Wi-Fi domestique",
    "wifi_description": "Appuyez sur le bouton Configurer le Wi-Fi à domicile, sélectionnez votre réseau domestique et enregistrer le mot de passe Wi-Fi.",
    "configure_wifi": "Configurer le Wi-Fi domestique",
    "cancel": "Annuler",
    "stickyNotification": "N’appuyez pas sur le bouton Précédent ou n’effectuez pas de mouvement de balayage pour terminer l’application (vous pouvez la réduire) pendant que vous essayez de reconnecter votre passerelle.",
    "enter_password": "Entrez le mot de passe pour",
    "password": "Mot de passe",
    "incorrect_password": "Mot de passe incorrect",
    "wifi_failureMsg": "La passerelle n’a pas pu se connecter à votre réseau Wi-Fi",
    "wifi_successMsg": "La passerelle est connectée au Wi-Fi",
    "envoyConnectToCellular": "Vous pouvez maintenant déconnecter votre appareil mobile du réseau de votre passerelle et le connecter à votre réseau Wi-Fi/activer vos données mobiles.",
    "envoyToastMessage": "Votre passerelle est connectée. Mais la mise à jour de l’état de votre passerelle peut durer environ 30 minutes.",
    "wifi_congratsMsg": "Félicitations! Vous êtes de retour en ligne. Vous pouvez maintenant reconnecter votre smartphone au réseau wifi domestique.",
    "tryagain": "Réessayer",
    "okay": "OK, j'ai compris",
    "failedToFetchWiFiNetworks": "Problème pour récupérer les réseaux Wi-Fi. Veuillez réessayer dans quelques minutes.",
    "noWifiNetworkFound": "Aucun réseau Wi-Fi trouvé. Redémarrez votre routeur Wi-Fi et réessayez.",
    "option2": "Si les étapes ci-dessus ne fonctionnent pas, apprenez comment le faire manuellement",
    "learnhow": "Apprendre comment faire",
    "ensureOn": "Assurez-vous que la passerelle est sous tension",
    "connectToPower": "Assurez-vous que votre passerelle est connectée à une source d’alimentation."
  },
  "whatsnews": {
    "monitorTitle": "Surveillance ",
    "monitorContent": "Vérifiez l'état du système en un coup d'œil grâce à un écran unique rassemblant les mesures essentielles.",
    "trackTitle": "Suivi",
    "trackContent": "Consultez vos tendances de production et de consommation d'énergie par jour, mois, année ou pour la vie entière grâce à différentes options d'affichage.",
    "reportTitle": "Rapport",
    "reportContent": "Contrôlez la production et l'utilisation d'énergie depuis l'application en créant des rapports quotidiens, hebdomadaires, mensuels ou pour une période de votre choix."
  },
  "theme": {
    "instructions": "Ensemble de couleur actuel",
    "night": "Nuit",
    "day": "Jour"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Charges",
    "generator": "Générateur",
    "noDeviceFound": "Aucun appareil trouvé",
    "searchMicroinverters": "Recherche de micro-onduleurs SN",
    "serialNumber": "SN",
    "configure": "Configurer",
    "connect": "Connecter",
    "envoy": "Passerelle",
    "microinverters": "Micro-onduleurs",
    "microinverter": "Micro-onduleur",
    "stringInverters": "String Inverter",
    "storage": "Batterie",
    "enpower": "Contrôleur du système",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Nombre de cycles",
    "cycleCountInfo": "Le nombre de cycles d’une batterie désigne le nombre total de cycles complets de charge et de décharge. Il est obtenu en divisant l’énergie totale accumulée par la capacité utilisable de la batterie. Le nombre indiqué ici représente le cycle terminé.",
    "status": "Statut",
    "array": "Tableau",
    "help": "Aidez-moi",
    "not_reporting": "Ne pas signaler",
    "not_reporting_lowercase": "ne pas signaler",
    "normal": "Normal",
    "home": "Accueil",
    "no_microinverters": "Aucun micro-onduleur trouvé",
    "no_storage": "Pas de stockage trouvé",
    "no_envoy": "Aucune passerelle trouvée",
    "no_enpower": "Aucun contrôleur du système trouvé",
    "wirelessRangeExtender": "Répéteur sans fil",
    "no_wirelessRangeExtender": "Aucun répéteur sans fil trouvé",
    "lastReported": "Dernier signalement",
    "manufacturer": "Nom du fabricant",
    "startType": "Type de démarrage",
    "fuelType": "Type de carburant",
    "modelNumber": "Numéro du modèle",
    "onOffCycles": "Total des cycles marche/arrêt",
    "maintainenceInfo": "Informations sur l’entretien",
    "maintainenceSub": "Mettez à jour ces données pour être informé de l’entretien de votre générateur et de vos besoins en carburant.",
    "lastMaintainenceDate": "Date du dernier entretien",
    "lastRefuellingDate": "Date du dernier ravitaillement en carburant",
    "lastRefuellingTime": "Durée du dernier ravitaillement en carburant",
    "lastMaintainenceTime": "Durée du dernier entretien",
    "litresOfFuel": "Liters of fuel filled",
    "additionalInfo": "Pour plus d’informations",
    "statistics": "Vos statistiques depuis le dernier entretien:",
    "timeElapsed": "Temps écoulé:",
    "cycles": "Cycles On/Off :",
    "runningHours": "Durée de l’opération:",
    "Days": "jours",
    "update": "Mise à jour",
    "clickHere": "cliquez ici",
    "savedSuccessfully": "Vos paramètres ont bien été enregistrés.",
    "loads": {
      "status": "Statut",
      "smartControl": "Contrôle intelligent",
      "auxillaryContact": "Contact auxiliaire"
    },
    "devicegenerator": {
      "on": "On",
      "off": "Off"
    },
    "connected": {
      "true": "Connecté au cloud d’Enphase",
      "false": "Déconnecté du cloud d’Enphase"
    },
    "envoyConnected": {
      "wait": "Recherche de la passerelle...",
      "true": "Passerelle détectée avec succès.",
      "false": "Passerelle non détectée."
    },
    "stepOne": "Connectez-vous directement à la passerelle. Pour ce faire, appuyez d’abord sur le bouton de connexion de la passerelle.",
    "stepTwo": "Accédez ensuite à vos paramètres Wi-Fi et connectez-vous au réseau de la passerelle :",
    "stepThree": "Une fois la connexion effectuée, revenez sur cet écran. Vous serez temporairement déconnecté d'Internet.",
    "connectLocally": "Connecter localement",
    "connectEnvoy": "Connectez-vous à la passerelle en utilisant",
    "connectEnvoyUser": "Nom d'utilisateur",
    "connectEnvoyPassword": "Mot de passe",
    "notAllowAPMode": "La passerelle ne prend pas en charge la connectivité locale.",
    "localEnvoyConnected": {
      "true": "Passerelle détectée avec succès",
      "false": "Aucune passerelle trouvée sur le réseau local",
      "wait": "Veuillez patienter..."
    },
    "envoyPwd": {
      "urenvPwd": "Mot de passe de votre passerelle",
      "retrivePwd": "Pour récupérer le mot de passe de votre passerelle :",
      "infoTitle": "Mot de passe de la passerelle",
      "infoDescription": "Vous aurez besoin de ce mot de passe pour reconnecter votre passerelle à votre réseau Wi-Fi. En général, cela se produit après un changement de mot de passe Wi-Fi ou de fournisseur de services.",
      "infoLearnMore": "Cliquez ici pour en savoir plus"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Allumez le Bluetooth de votre téléphone pour le connecter à votre IQ Gateway",
      "tryApMode": "Essayer le Mode AP",
      "gatewayNotFound": "IQ Gateway non trouvable. Assurez-vous que votre IQ Gateway est à proximité et allumée.",
      "bleNotSupported": "Bluetooth non pris en charge",
      "bleNotSupportedDesc": "Bluetooth non pris en charge sur votre appareil, veuillez vous assurer que votre appareil possède le Bluetooth et des options de Localisation.",
      "bleConnected": "Bluetooth connecté",
      "scanningGateway": "Scannage pour chercher l’IQ Gateway",
      "fewMints": "Cela peut prendre quelques minutes",
      "noWifi": "Aucun appareil Wi-Fi trouvé",
      "password": "Mot de passe",
      "gatewayConnected": "L’IQ Gateway est bien connecté au Wi-Fi.",
      "okGotIt": "D’accord, j’ai compris",
      "noGateway": "IQ Gateway non trouvée",
      "gatewayNearByWarning": "Assurez-vous que votre passerelle est à proximité et allumée.",
      "noNetwork": "Aucun réseau",
      "wifiRouterWarning": "Gardez le routeur Wi-Fi allumé et votre IQ Gateway à portée du Wi-Fi",
      "connectionError": "Erreur de connexion",
      "turnOn": "Activer",
      "failedWifiConnect_1": "Échec de connexion au réseau Wi-Fi. Veuillez ",
      "failedWifiConnect_2": "Contacter l’assistance",
      "failedWifiConnect_3": " pour obtenir de l’aide.",
      "failedIQConnect_1": "Échec de connexion à l’IQ Gateway. Veuillez ",
      "failedIQConnect_2": "Contacter l’assistance",
      "failedIQConnect_3": " pour obtenir de l’aide.",
      "bleDevices": "Périphériques Bluetooth",
      "wifiNetworks": "Réseaux Wi-Fi",
      "connectBle": "Connectez-vous au Bluetooth",
      "gatewayToWifi": "Connexion de l’IQ Gateway au Wi-Fi…",
      "bleStatus": "Vérification de l’état du Bluetooth…",
      "searchingWifi": "Recherche de réseaux Wi-Fi...",
      "connectingBle": "Connexion au Bluetooth",
      "turnOnBle": "Activer Bluetooth",
      "tryAgain": "Réessayer",
      "wifiSsIdConfigFailedDesc": "Une erreur inconnue s'est produite lors de la connexion au réseau Wi-Fi. Veuillez réessayer plus tard ou vous connecter à un autre réseau.",
      "wifiCommunicationError": "Erreur de communication Wi-Fi",
      "wifiCommunicationErrorDesc": "Impossible d'établir la connexion avec le module BLE de la passerelle IQ. Merci d'essayer plus tard.",
      "networkNotFound": "Réseau introuvable",
      "networkNotFoundDesc": "Le réseau auquel vous essayez de vous connecter est introuvable. Assurez-vous que le routeur Wi-Fi est activé ou essayez un autre réseau."
    }
  },
  "notification": {
    "offline": "Hors ligne",
    "apmode": "Mode AP"
  },
  "siteempty": {
    "nosystemassociated": "Votre compte n'est actuellement associé à aucun système.",
    "systemowner": "Vous possédez un système Enphase ?",
    "contactyourinstaller": "Contactez votre installateur pour vérifier le compte associé à votre système.",
    "interestedonsystem": "Vous êtes intéressé par un système Enphase ?",
    "initiatetransferofwarranty": "Effectuez un transfert de garantie si vous avez acheté une propriété avec un système Enphase.",
    "applytransferownership": "Demandez un transfert de propriété ici.",
    "ownershiptransfer": "Transfert de propriété",
    "visita": "Rendez-vous sur une",
    "publicsystempage": "page système publique",
    "monitoringexperience": "pour découvrir les systèmes de surveillance Enphase."
  },
  "recaptcha": {
    "verification_failed": "Échec de la vérification reCAPTCHA. Réessayez.",
    "recaptcha_unreachable": "Nous n'avons pas réussi à valider votre réponse reCAPTCHA. Réessayez."
  },
  "mobile_app_rating": {
    "enjoying_app": "Vous appréciez l’application Enphase ?",
    "rate_on_play_store": "Évaluez votre expérience",
    "rate_on_play_store2": "Sur le Play Store",
    "rate_us": "Évaluez-nous maintenant",
    "may_be_next": "Peut-être la prochaine fois"
  },
  "consumptionMtr": {
    "btnText": "Ajouter un compteur de consommation",
    "infoText": "Le compteur de consommation vous aide à suivre votre consommation globale d'énergie"
  },
  "replacement": {
    "microinverter_not_reporting": "Les micro-onduleurs ne génèrent pas de rapport.",
    "batteryWarning": 'Cela peut se produire si la communication sans fil entre votre passerelle et la batterie n’est pas solide. Il peut s’agir d’un problème temporaire et cela devrait rapidement être réglé. Si le problème persiste, veuillez contacter votre agent de maintenance pour obtenir de l’aide.',
    "controllerWarning": 'Cela peut se produire si la communication sans fil entre votre passerelle et le contrôleur de système n’est pas solide. Il peut s’agir d’un problème temporaire et cela devrait rapidement être réglé. Si le problème persiste, veuillez contacter votre agent de maintenance pour obtenir de l’aide.',
    "batteryError": 'La batterie ne génère aucune donnée.',
    "controllerError": 'Le contrôleur de système n’envoie pas de rapport.',
    "contactMaintainer": "Contacter votre mainteneur pour obtenir de l'aide.",
    "systemWarning": 'avertissement du système',
    "array_details": "Détails de la gamme",
    "replacement_warranty1": "",
    "replacement_warranty": "micro-onduleurs sont sous garantie et éligibles pour le remplacement.",
    "shipping_address": "Adresse d’expédition",
    "site_address": "Adresse du site",
    "change": "CHANGER",
    "select_microinverters": "SÉLECTIONNER LES MICRO-ONDULEURS",
    "serial_number": "Rechercher un numéro de série",
    "status": "Statut",
    "normal": "Normal",
    "not_reporting": "N’envoie pas de rapport",
    "submit_request": "Envoyer une demande",
    "dear": "choisieCher",
    "replacement_message1": "vous pourriez avoir besoin de contacter votre Installateur",
    "replacement_message2": "pour effectuer le remplacement, une fois l’appareil de remplacement expédié. Votre installateur peut vous facturer des frais de remplacement.",
    "request_submitted": "Votre demande de retour a été envoyé avec succès.",
    "response_message": "Utilisez l’ID de demande pour suivre le statut de remplacement lorsque vous contactez le support.",
    "request_id": "ID de demande",
    "ok": "OK, j’ai compris",
    "replacement_delivery": "Le remplacement sera livré à votre site",
    "replacement_delivery_installer": "Le remplacement sera livré à votre installateur local",
    "installer_address": "ADRESSE DE L’INSTALLATEUR",
    "understand": "Je comprend",
    "continue_button": "Continuer",
    "error_message": "Échec de la génération de l'ID de demande.",
    "failed_to_fetch": "Échec de la récupération des micro-onduleurs. Veuillez réessayer",
    "change_address": "Changer l’adresse d’expédition"
  },
  "tariff": {
    "tariff": "Tarif",
    "tariffNotAdded": "Le tarif n'est pas ajouté",
    "tariffNotSet": "Le tarif n’est pas défini",
    "tariffType": "Type de tarif",
    "buying": "Achat",
    "selling": "Vente",
    "flat": "Taux fixe",
    "tou": "Heure de consommation",
    "tiered": "Tarification différenciée",
    "copyFromBuyingTariff": "Copie à partir du tarif d’achat",
    "copyFromSellingTariff": "Copie à partir du tarif de vente",
    "dayBasedTariff": "Votre tarif varie-t-il pendant la journée ?",
    "unitsBasedTariff": "Votre tarif varie-t-il selon les unités consommées ?",
    "seasonalTariff": "Votre tarif varie-t-il selon les saisons?",
    "weekendTariff": "Votre tarif varie-t-il le weekend?",
    "baseRateTariff": "Quel est le taux de base?",
    "flatLabel": "Le coût de l’énergie est fixe tout au long de la journée.",
    "touLabel": "Le coût de l’énergie varie pendant les heures pleines.",
    "tieredLabel": "Le coût de l’énergie varie en fonction de l’augmentation de la consommation unitaire.",
    "rate": "Tarif",
    "addSeason": "Ajouter une saison",
    "season": "Saison",
    "next": "Suivant",
    "noSeasonWeekend": "Le tarif ne varie ni en fonction de la saison, ni le weekend.",
    "weekendOnly": "Le tarif ne varie que le weekend.",
    "seasonAndWeekend": "Le tarif varie en fonction de la saison et le weekend.",
    "seasonOnly": "Le tarif ne varie qu’en fonction de la saison.",
    "infoText": "Info",
    "baseRate": "Taux de base",
    "remove": "Supprimer",
    "from": "De",
    "to": "À",
    "addPeak": "Ajouter un pic",
    "tariffDetails": "Détails des tarifs",
    "off-peak": "Off-Peak",
    "above": "Au-dessus",
    "below": "Au dessous de",
    "between": "Entre",
    "and": "et  ",
    "weekdays": "jours de la semaine",
    "weekend": "weekend",
    "winter": "Hiver",
    "summer": "Été",
    "fall": "Automne",
    "spring": "Printemps",
    "confirmAndSave": "Confirmer & Enregistrer",
    "buyingTariff": "Tarif d'achat",
    "sellingTariff": "Tarif de vente",
    "edit": "Modifier",
    "offPeak": "Heures creuses",
    "peak": "Heures pleines",
    "period": "Heures pleines",
    "addTier": "Ajouter un niveau",
    "tier": "Niveau",
    "yesLabel": "Oui",
    "noLabel": "non",
    "manualConfiguration": "Configuration manuelle",
    "added": "ajouté",
    "modified": "modifié",
    "successfully": "avec succès",
    "alreadySelected": "est déjà sélectionné",
    "alreadyAdded": "est déjà ajouté",
    "buyingTariffAdded": "Tarif d’achat ajouté avec succès",
    "sellingTariffAdded": "Tarif de vente ajouté avec succès",
    "buyingTariffModified": "Tarif d’achat modifié avec succès",
    "sellingTariffModified": "Tarif de vente modifié avec succès",
    "buyingTariffReset": "Tarif d’achat réinitialisé avec succès",
    "sellingTariffReset": "Tarif de vente réinitialisé avec succès",
    "reset": "Réinitialiser",
    "resetConfirmationText": "Êtes-vous sûr de vouloir réinitialiser les détails des tarifs ?",
    "resetErrorText": "Impossible de réinitialiser les détails des tarifs",
    "updateErrorText": "Impossible de mettre à jour les détails des tarifs",
    "tariffErrorText": "Entrée invalide. Cette valeur existe déjà dans ce palier ",
    "tierInvalidEntry": "Entrée invalide. La valeur doit être supérieure à « Niveau 1 »",
    "timeInvalidEntry": "Entrée invalide. La valeur doit être supérieur à « De »",
    "invalidValue": "La valeur doit être supérieure à 0"
  },
  "currency": {
    "currencyEquivalent": "Voir l’équivalent en devise des valeurs d’énergie",
    "currencyConversion": "Définir le facteur de conversion de la devise",
    "currencyInfo": "La valeur monétaire rapportée est une estimation moyenne puisqu’elle ne prend pas en compte les taxes, les frais, les la tarification différenciée, la demande ou la tarification en fonction de l’heure de consommation.",
    "currencyFactor": "Facteur de conversion de devise",
    "currencyFactorSubtitle": "Les données d’énergie sont converties en leur valeur équivalente en devise en les multipliant par le facteur de conversion de devise.",
    "currencyNote": "Note : La valeur monétaire rapportée est une estimation moyenne puisqu’elle ne prend pas en compte les taxes, les frais, les la tarification différenciée, la demande ou la tarification en fonction de l’heure de consommation.",
    "conversionFactor": "Facteur de conversion",
    "currencyEquivalentHeader": "Équivalent en devise",
    "energyImported": "Énergie importée",
    "energyExported": "Énergie exportée",
    "netEnergyImported": "Énergie importée nette",
    "netEnergyExported": "Énergie exportée nette",
    "currencyConversionHeader": "Conversion de devise",
    "confirmationMessage": "Souhaitez-vous continuer sans enregistrer les modifications?",
    "confirmationYes": "Oui",
    "confirmationNo": "Non",
    "invalidInput": "Entrée invalide"
  },
  "demo": {
    "appDemo": "Démo de l’application",
    "message": "Ceci est une application de démonstration",
    "enphaseInstaller": "Enphase Installer",
    "mainHeader": "Système énergétique intelligent tout en un",
    "subHeader": "Obtenir l’énergie solaire et le stockage",
    "getStarted": "Démarrer",
    "appDemoDesc": "Appuyez pour voir comment fonctionne un système",
    "loginDesc": "Pour les utilisateurs enregistrés",
    "selectLanguage": "Sélectionnez la langue"
  },
  "connectionBandwidth": {
    "low": "Bas débit. Rapporte les données toutes les 6 heures",
    "high": "Bande passante standard. Rapporte les données toutes les 15 minutes"
  },
  "release_notes": {
    "appUpdateHeading": "Nouvelle mise à jour de votre application Enphase",
    "appUpdateSuccessHeading": "Votre application Enphase a été mise à jour.",
    "later": "Plus tard",
    "updateNow": "Mettre à jour maintenant",
    "update": "Mise à jour",
    "whatsNew": "Voici les nouveautés",
    "askWhatsNew": "Quelles sont les nouveautés ?",
    "new": "Nouveau",
    "version": "Version",
    "readMore": "En lire plus"
  },
  "storageCapacity": {
    "availableEnergy": "Énergie disponible",
    "totalStorage": "Stockage total",
    "encharge": "IQ Battery",
    "acBattery": "Batterie AC",
    "of": "de",
    "availablePower": "Puissance disponible",
    "activeMicroinverters": "Micro-onduleur(s) actif(s)",
    "activeEncharge": "Batterie(s) active(s)",
    "microinverters": "Micro-onduleur(s)"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Téléchargez une image du site de votre choix",
    "selectImage": "Sélectionner Une Image",
    "imageSizeError": "*La taille de l'image doit être inférieure à 5 Mo",
    "hide": "Cacher",
    "apply": "Appliquer",
    "hideSiteImage": "Masquer l'image du site",
    "hideSiteImageDesc1": "L'image du site ne sera pas affichée sur la page d'état. Vous pouvez modifier la préférence en allant dans Menu -> Système -> Détails du site.",
    "hideSiteImageDesc2": "Voulez-vous poursuivre?",
    "uploadSuccessToast": "L'image de votre site a été mise à jour avec succès",
    "maxImageLimit": "Vous pouvez télécharger jusqu'à quatre images pour votre site. Veuillez supprimer une image pour en ajouter une nouvelle.",
    "okGotIt": "D’accord, j’ai compris!",
    "imageSIzeErrorSiteDetails": "La taille de l'image doit être inférieure à 5 Mo. Veuillez télécharger une autre image.",
    "apiError": "Impossible de terminer la demande. Veuillez réessayer plus tard",
    "displayOnStatusPage": "Affichage sur la page d'état",
    "displayOnStatusPageWarning": "Voulez-vous vraiment mettre à jour l'image sur la page d'état ?",
    "displayOnStatusPageNote": "Remarque : L'image sera ajustée automatiquement pour s'afficher. Vous pouvez toujours le réajuster sur la page Statut",
    "deleteSiteImage": "Supprimer l'image",
    "deleteSiteImageWarning": "Voulez-vous vraiment supprimer l'image ?",
    "imageDeleteSuccess": "L'image a été supprimée avec succès",
    "imageUploadSuccess": "L'image est téléchargée avec succès",
    "imageUploadSuccessStatusPage": "Image mise à jour avec succès sur la page d'état",
    "displayedOnStatusPage": "Affiché sur la page d'état",
    "uploadImage": "Télécharger l'image",
    "imagePreferenceSaved": "Votre préférence d'image de site est enregistrée",
    "siteImage": "Image du site",
    "statusPageMaxImagePopUpDesc1": "Vous pouvez télécharger jusqu'à quatre images pour votre site. Veuillez supprimer une image de ",
    "statusPageMaxImagePopUpDesc2": " pour en ajouter une nouvelle ici",
    "addSiteImage": "AJOUTER UNE IMAGE AU SITE",
    "wrongFileType": "Veuillez télécharger une image JPEG ou PNG uniquement"
  },
  "nps": {
    "question": "Quelle a été votre expérience avec nous ?",
    "description": "Selon votre expérience récente avec Enphase, recommanderiez-vous Enphase à un ami ou un collègue ?",
    "dontAskAgain": "Ne plus me demander",
    "notNow": "Pas maintenant",
    "notLikely": "Peu probable",
    "mostLikely": "Très probable",
    "confirmationHeader": "Merci de votre réponse ! Aidez-nous à mieux comprendre votre réponse.",
    "surveyButton": "Prenez 2 minutes pour répondre à ce questionnaire",
    "notInterested": "Pas intéressé",
    "survey": "Questionnaire",
    "internetError": "Veuillez vérifier votre connexion Internet et réessayer.",
    "rateEnphaseTitle": "Évaluer Enphase",
    "rateEnphaseDescription": "Quelle est la probabilité que vous recommandiez Enphase à un ami ou un collègue ?",
    "rateInstallerTitle": "Évaluer votre installateur",
    "rateInstallerDescription1": "Quelle est la probabilité que vous recommandiez",
    "rateInstallerDescription2": "à votre ami ou votre collègue ?",
    "feedbackSuccess": "Nous vous remercions de votre précieux retour.",
    "ratingSuccess": "Merci pour votre avis.",
    "feedbackEnphaseTitle": "Votre note Enphase",
    "feedbackInstallerTitle": "Votre note d'installateur",
    "detractors": "Que pourrions-nous faire de mieux?",
    "passive": "Que pourrions-nous faire pour améliorer votre expérience?",
    "promoters": "Aidez-nous en expliquant votre score?",
    "legalDisclaimer": "Votre nom et votre retour/vos commentaires seront partagés avec les installateurs."
  },
  "liveStatus": {
    "title": "Statut en direct",
    "subTitle": "Voir l’énergie en temps réel",
    "offlineMsg": "Use LIVE STATUS when Offline",
    "streamingLocally": "Diffusion en continu en local à partir de la passerelle",
    "closingMinutes": "Fermeture",
    "cfgMsg": "Les batteries peuvent se recharger à partir du réseau car vous avez activé le paramètre %{cfglink}.",
    "learn": "Apprendre",
    "pvOnlyCta": "%{learn} comment vous pouvez optimiser et suivre votre consommation d'énergie à l'aide de la mesure de la consommation",
    "cfgFiller": "Charger la batterie depuis le réseau",
    "cfgVls": "Les batteries pourraient se charger à partir du réseau si la charge de vos batteries est inférieure au niveau d’arrêt.",
    "solar": {
      "title": "Solaire",
      "producing": "Production",
      "energyProducing": "Production d’énergie"
    },
    "home": {
      "title": "Domicile",
      "consuming": "Consommé",
      "energyConsuming": "Consommation d’énergie"
    },
    "grid": {
      "title": "Réseau",
      "gridConnectivity": "Connectivité au réseau",
      "waiting": "Warten auf Informationen",
      "unknown": "Statut du réseau inconnu",
      "notAvailable": "Le réseau n’est pas disponible",
      "systemConnected": "Système est sur le réseau",
      "notSystemConnected": "Système n’est pas sur le réseau",
      "outage": "Grid Outage",
      "updating": "Mise à jour du statut du réseau",
      "exporting": "Exportation",
      "importing": "Importation",
      "notConnected": "Non connecté",
      "offGrid": "Réseau Off",
      "onGrid": "Réseau On",
      "goOnGrid": "Se connecter au réseau",
      "goOffGridDisabled": "Mode déconnecté du réseau non autorisé",
      "goOffGrid": "Se déconnecter du réseau",
      "gridUpdatingMessage": "La confirmation du statut du réseau prend plus longtemps que prévu. Veuillez vérifier plus tard.",
      "gridConnectedMessage": "votre système est maintenant connecté au réseau",
      "gridDisconnectedMessage": "votre système est maintenant déconnecté du réseau",
      "disconnectingGrid": "Déconnexion du réseau...",
      "connectingGrid": "Connexion au réseau...",
      "unableToConnect": "Impossible de se connecter à la passerelle",
      "initialisingOnGrid": "Initialisation du contrôle du réseau...",
      "gridOutage": "Le système est Déconnecté du réseau en raison d’une panne du réseau",
      "gridOutageToastAuto": "Vous ne pouvez pas être Connecté au réseau en raison de la panne de courant. Lorsque le courant sera restauré, le système vous reconnectera au réseau",
      "gridOutageToastUser": "Vous ne pouvez pas être Connecté au réseau en raison de la panne de courant. Vous pouvez contrôler la connexion au réseau une fois que le réseau public est disponible"
    },
    "generator": {
      "title": "Générateur",
      "onGenerator": "Générateur On",
      "offGenerator": "Générateur Off",
      "unknown": "Générateur statut inconnu",
      "notConnected": "Non connecté",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Mise à jour",
      "updating": "Commander maintenant"
    },
    "fuelCell": {
      "title": "Pile à combustible",
      "on": "Pile à combustible allumé",
      "off": "Pile à combustible éteinte",
      "warmingUp": "La pile à combustible se réchauffe",
      "coolDown": "La pile à combustible refroidit",
      "unknown": "Statut de la pile à combustible inconnu",
      "notConnected": "Non connecté",
      "genDisconnecting": "Déconnexion...",
      "waiting": "En attente",
      "updating": "Mise à jour"
    },
    "systemNotReporting": {
      "title": "Le contrôleur de système n’envoie pas de rapport",
      "subTitle": "Nous ne sommes pas en mesure d’afficher les données en direct puisque votre contrôleur de système n’envoie pas de rapport à la passerelle. Il peut s’agir d’un problème temporaire et cela devrait rapidement être réglé."
    },
    "envoy": {
      "connecting": "Connexion à la passerelle...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Impossible de se connecter",
      "notAbleToConnectMultiEnv": "Pas en mesure de se connecter au NS de la passerelle:",
      "negativeConsumptionTitle": "Erreur de communication",
      "negativeConsumptionDesc": "Nous ne sommes pas en mesure d’afficher le statut en direct complet en raison d’une perte de communication entre vos appareils. Il s'agit d’un problème temporaire qui devrait être rapidement résolu."
    },
    "onDifferentNetwork": "Votre passerelle et ce périphérique sont sur un réseau différent",
    "connectOnSameNetworkorAPMode": "Connectez votre passerelle et le périphérique au même réseau ou activez le mode AP sur votre passerelle pour connecter ce périphérique au réseau Wi-Fi %{ssid}",
    "connectOnSameNetwork": "Connectez ce périphérique au réseau Wi-Fi %{ssid} puis réessayez pour afficher l'état en temps réel en mode hors connexion.",
    "apModeTutorial": "Tutoriel du mode AP",
    "apMT1": "Appuyez et relâchez (ne maintenez pas) le ",
    "apMT2": "bouton du Mode AP",
    "apMT3": "jusqu’à ce que le voyant de la LED du Mode AP (",
    "apMT4": ") s’allume en vert fixe. La passerelle restera en mode AP pendant huit heures."
  },
  "desktop": {
    "status": {
      "power": "Puissance",
      "energy": "Énergie",
      "solarEquivalent": "Équivalent solaire",
      "dataUnavailable": "Les données ne sont pas disponibles"
    },
    "array": {
      "title": "Tableau",
      "totalProduced": "Total Produit",
      "totalConsumed": "Total Consommé",
      "lifetimeProduced": "Cumul de production",
      "lifetimeConsumed": "Durée de vie consommée",
      "status": "Statut",
      "azimuth": "Azimut",
      "tilt": "Inclinaison",
      "microinverter": "Micro-inverseur"
    },
    "energy": {
      "totalEnergy": "Énergie totale",
      "graphControls": "Commandes du graphique"
    },
    "header": {
      "switchToClassic": "Passer à la vue classique"
    },
    "footer": {
      "change": "Changer",
      "changeSite": "Changer le site",
      "copyRightsText": "©2008-%{currYear} Enphase Energy Inc. Tous droits réservés.",
      "privacyText": "Confidentialité",
      "termsText": "Conditions",
      "weatherCompany": "La Weather Company",
      "weatherDataText": "Données météorologiques fournies par"
    }
  },
  "customPeriod": {
    "dialogLabel": "Vue selon",
    "billingCycle": "Le cycle de facturation",
    "billingLabel": "Faire correspondre le graphique de consommation d’énergie à votre cycle de facturation",
    "startDate": "Date de début de la facturation",
    "billingLabelStatusPage": "Période démarrant à la date de début sélectionnée pendant la durée sélectionnée",
    "frequency": "Fréquence de facturation",
    "months": "Mois",
    "days": "Jour",
    "every": "Chaque",
    "customDate": "Période personnalisée",
    "customDateLabel": "Sélectionnée une plage de date personnalisée pour la voir sur le graphique de consommation d’énergie",
    "customRange": "Veuillez sélectionner un intervalle de date entre 1 à 100 jours"
  },
  "systemEstimator": {
    "heading": "Estimateur de système",
    "exitConfirmation": "Voulez-vous vraiment fermer le flux d'ajout de stockage?",
    "resumeButton": "Reprendre",
    "systemAccess": "Obtenez l'accès au système",
    "statusAddStorage": "to avoid blackouts",
    "addStorageLeadInfo": "voir le statut",
    "postLoginWoSiteTitle": "Découvrez le seul système solaire et de stockage tout-en-un",
    "videoCTABtn": "Regarder la vidéo",
    "addStorageTitle": "Obtenez un nouveau système Enphase",
    "orderNowBtn": "Commandez maintenant"
  },
  "sgipIncentive": {
    "gotItButton": "D’accord",
    "exitButton": "Quitter",
    "dontExitButton": "Ne pas quitter",
    "sgipPaymentNotDone": "Votre demande SGIP est incomplète. Souhaitez-vous quitter sans terminer votre demande ?",
    "sgipPaymentDone": "Vous pouvez revenir à tout moment pour vérifier le statut de votre demande SGIP",
    "sgipApplyAlert": "Les mesures d’incitation SGIP s’appliquent aux systèmes installés en Californie uniquement. Si vous avez déjà une activation de système en cours en Californie, demandez à votre installateur de lancer le processus de création de site dans son application Enphase.",
    "sgipGetStorage": "Obtenir un nouveau système de stockage Enphase"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "L'état de la grille est devenu",
    "gridOn": "Sur la grille",
    "gridOff": "Hors réseau",
    "batteryChangeDesc": "Le profil de la batterie a été remplacé par",
    "costSavings": "Économies de coûts",
    "selfConsumption": "Consommation personnelle",
    "savingsMode": "Mode économie",
    "backupOnly": "Sauvegarde uniquement",
    "stormGuardDesc": "La Protection contre les tempêtes est",
    "alertIssued": " alerte émise",
    "alertHasEnded": " l’alerte est terminée"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normal",
    "unknown": "Inconnu",
    "undefined": "Non défini",
    "loads": "Contrôle de charge",
    "loadsInfoPart1": "Les charges sont cartographiées par votre installateur d’après les ",
    "loadsInfoPart2": "Contacts auxiliaires du contrôleur du système",
    "loadsInfoPart3": ". Vous pouvez configurer ces charges dans vos ",
    "loadsInfoPart4": "paramètres système",
    "powered": "Alimenté",
    "invalidState": "État invalide",
    "viewMore": "Voir plus",
    "viewLess": "Voir moins",
    "ECA_BAT_IDLE": "Inactif",
    "ECA_BAT_CHARGING": "Chargement",
    "ECA_BAT_DISCHARGING": "Déchargement",
    "MAX_ECA_BAT_STATE": "Inconnu",
    "systemIsOnGrid": "Le système est sur le réseau",
    "systemIsOffGrid": "Le système n’est pas sur le réseau",
    "infoIsOnGrid": "Le système fonctionne en mode connecté au réseau.",
    "infoIsOffGrid": "Le système fonctionne en mode micro-réseau.",
    "wiredCANConn": "Connexion CAN filaire",
    "infoWiredCAN": "L’IQ System Controller communique avec l’IQ Gateway par connexion sans fil. L’icône indique s’il est connecté ou non et communique avec la passerelle.",
    "infoIsOffGridAvailable": "Le système fonctionne en mode micro-réseau. Cependant, le réseau est disponible et vous pouvez choisir de passer sur le réseau à tout moment.",
    "voltageL1": {
      "val": "Tension L1",
      "info": "La tension entre la Ligne 1 (L1) et le Neutre."
    },
    "voltageL2": {
      "val": "Tension L2",
      "info": "La tension entre la Ligne 2 (L2) et le Neutre."
    },
    "voltageL3": {
      "val": "Tension L3",
      "info": "La tension entre la Ligne 3 (L3) et le Neutre."
    },
    "voltage": {
      "val": "Tension",
      "info": "La tension entre la Ligne 1 (L1) et le Neutre."
    },
    "frequency": {
      "val": "Fréquence",
      "info": "La fréquence nominale du courant alternatif (AC)."
    },
    "gridParameters": "Paramètres du réseau public",
    "auxiliaryContactsParameters": "Contrôle de charge",
    "infoauxiliaryContactsParam": "Le contrôleur du système possède quatre contacts auxiliaires pour le contrôle de la charge. Le nom de la charge indique que le contact correspondant est associé à cette charge. Pour les contacts qui ne sont associés à aucune charge, le message « Non utilisé » s’affiche.",
    "infoGridParam": "La tension et la fréquence du réseau sont mesurées du côté réseau public de l’appareil d’interconnexion du micro-réseau (MID). Lorsque le réseau n’est pas disponible, la tension et la fréquence du réseau sont de 0.",
    "microgridParameters": "Paramètres du micro-réseau",
    "infoMicrogridParam": "La tension et la fréquence du micro-réseau sont mesurées du côté charge de l’appareil d'interconnexion du micro-réseau (MID). Si votre MID est ouvert, alors votre système est en mode hors réseau / micro-réseau.",
    "generatorParameters": "Paramètres du générateur",
    "infoGeneratorParam": "La tension et la fréquence du générateur sont mesurées du côté charge de l’appareil d'interconnexion du générateur (GID). Si votre GID est fermé, alors votre système est en mode hors réseau / micro-réseau.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Signal de communication",
    "infoZigbeeSignal": "Représente la puissance de la communication sans fil de 2,4 GHz avec la passerelle. Plus il y a de barres ou plus la valeur en dBm est élevée, plus le signal est fort.",
    "commStatus": "État de la communication",
    "infoCommSignal": "SIGNAL DE LA COMMUNICATION",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "IQ System Controller communique avec l’IQ Gateway par connexion USB. L’icône indique si l’USB est connecté et communique avec l’IQ Gateway ou non.",
    "commStatusDesc": "IQ Battery communique avec l’IQ System Controller par connexion filaire. L’icône indique si IQ Battery est connecté et communique avec l’IQ System Controller ou non.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Inconnu"
    },
    "ENCMN_STATE_MISSING": {
      "val": "Échec de la communication à 2,4 GHz"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "2.4 GHz pairing"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "Association à 2,4 GHz terminée"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Récupération des informations de l’appareil terminée"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "En attente de la confirmation de l’état du réseau par les batteries"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Commande du contrôleur du système pour fermer le relais EC1"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Inconnu"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Début de la mise à jour du profil réseau"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Mise à jour du profil réseau en cours"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Mise à jour du profil réseau terminée"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Récupération des états des relais du contrôleur du système après l’initialisation"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Interprétation des états des relais du contrôleur du système"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "Le contrôleur du système est Hors réseau"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "Le contrôleur du système est Hors réseau. Le réseau est disponible"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "Le micro-réseau est synchronisé au réseau. Prêt à se connecter au réseau"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "Le contrôleur du système est En réseau"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Commande du contrôleur du système pour passer en réseau"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Préparation à l’exécution de la commande utilisateur pour se connecter au réseau"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Commande du contrôleur du système pour passer hors réseau"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "Le contrôleur du systèmes est connecté au réseau. Recherche des batteries."
    },
    "ENCMN_STATE_MAX": {
      "val": "Inconnu"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "No micros detected"
    },
    "ENCHG_STATE_READY": {
      "val": "La batterie est opérationnelle"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Envoi du mode réseau à la batterie"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Mise à jour de la limite d’état de charge (SOC) de la réserve de la batterie"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Début de la mise à jour du profil réseau"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Mise à jour du profil réseau en cours"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Mise à jour du profil réseau terminée"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Récupération des informations matérielles et logicielles provenant de la batterie"
    },
    "ST_NOP": {
      "val": "Inconnu"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "Le contrôleur du système est Hors réseau. Connexion au générateur."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "Le contrôleur du système est Hors réseau. Générateur connecté"
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "Le contrôleur du système est Hors réseau. Déconnexion du générateur."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 fermé. Test du relais terminé."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 ouvert. Test du relais en cours."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "Relais GEN fermé. Test du relais terminé."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "Relais GEN ouvert. Test du relais en cours."
    },
    "default": {
      "val": "Inconnu"
    },
    "controlState": "État de contrôle",
    "CHECK_BUSES": {
      "val": "Vérification des buses et des relais",
      "info": "Le contrôleur du système a été réinitialisé. Validation des paramètres du système avant le passage à un autre état du réseau."
    },
    "CYCLE_RELAYS": {
      "val": "Commutation des relais",
      "info": "Votre système effectue des cycles sur les relais du contrôleur du système pour vérifier si les conditions d’erreur des relais ont disparu."
    },
    "GRID_CONNECT": {
      "val": "Connexion au réseau",
      "info": "Votre système se connecte au réseau après la réinitialisation du contrôleur du système."
    },
    "EC1_EC2_CONNECT": {
      "val": "Batteries connectées. Connexion du NFT",
      "info": "Votre système est en train de passer au micro-réseau. Les batteries sont connectées. Le transformateur de formation de neutre (NFT) est en cours de connexion."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "En réseau. Connexion des batteries",
      "info": "Votre système est En réseau. Les batteries sont en cours de connexion."
    },
    "GRID_OP_FULL": {
      "val": "Sur le réseau",
      "info": "Votre réseau fonctionne en mode connecté au réseau."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Hors réseau",
      "info": "Votre système fonctionne en mode micro-réseau."
    },
    "SYNC_TO_GRID": {
      "val": "Synchronisation au réseau",
      "info": "Votre système passe du micro-réseau au réseau."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Défaillance du micro-réseau",
      "info": "Le micro-réseau s’est effondré en raison d’une surcharge ou d’une erreur système. Le système va bientôt se restaurer."
    },
    "MANUFACTURING_MODE": {
      "val": "Mode usine",
      "info": "Veuillez contacter l’assistance clientèle."
    },
    "RESET": {
      "val": "Réinitialisation du contrôleur du système",
      "info": "Votre contrôleur du système a été réinitialisé. Le système va bientôt être rétabli."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "Sur le réseau. Ouverture du NFT",
      "info": "Votre système est sur le réseau. Le transformateur à point neutre (NFT) est en cours de déconnexion."
    },
    "MANUAL_OVERRIDE": {
      "val": "Commande manuelle activée",
      "info": "Vous avez manuellement fermé l’appareil d’interconnexion au micro-réseau (MID) pour passer sur le réseau. Veuillez appeler l’assistance clientèle si vous n’avez pas fait cette manipulation intentionnellement."
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Inconnu",
      "info": "Veuillez contacter l’assistance clientèle."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Synchronisé et en cours de connexion au réseau"
    },
    "infoControlState": "États de contrôle",
    "faults": "Erreur du contrôleur du système",
    "MID_FUSED": "Votre système ne peut passer en mode micro-réseau puisque le MID est bloqué en position fermée.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Les relais du transformateur à point neutre (NFT) sont bloqués en position fermée.",
    "NFT_OPEN": "Votre système ne peut pas passer en mode micro-réseau puisque les relais du transformateur à point neutre (NFT) sont bloqués en position ouverte.",
    "MID_OPEN": "Votre système ne peut pas passer en mode connecté au réseau puisque le MID est bloqué en position ouverte.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Votre système n’est pas opérationnel. Le tableau du commutateur de transfert automatique (ATS) du contrôleur du système est en panne.",
    "ADC_INIT": "Votre système n’est pas opérationnel. Le tableau du commutateur de transfert automatique (ATS) du contrôleur du système est en panne.",
    "I2C_COMM": "Votre système n’est pas opérationnel. Le tableau du commutateur de transfert automatique (ATS) du contrôleur du système est en panne.",
    "NFT_TEMP": "Votre système n’est pas opérationnel. Le transformateur de formation de neutre (NFT) du contrôleur du système a dépassé les limites de température.",
    "ATS_TEMP": "Votre système n’est pas opérationnel. Le tableau du commutateur de transfert automatique (ATS) du contrôleur du système a dépassé les limites de température.",
    "E3_TEMP": "Votre système n’est pas opérationnel. Le tableau du contrôleur du système a dépassé les limites de température.",
    "CRC_MISMATCH": "Votre système n’est pas opérationnel. Le tableau du contrôleur du système n’a pas réussi à s’initialiser.",
    "V_IMBALANCE": "Votre système ne peut pas passer en mode micro-réseau. Un déséquilibre de tension entre L1 et L2 a provoqué un déclenchement.",
    "MANUAL_OVR": "Votre système est en mode connecté au réseau en raison d’une commande prioritaire manuelle du contrôleur du système.",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "L’appareil d’interconnexion au micro-réseau (MID) connecte (lorsqu’il est fermé) votre domicile au ou le déconnecte (lorsqu’il est ouvert) du réseau public."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Le DER L1 des relais des ressources énergétiques distribuées (DER) lorsqu’il est fermé connecte vos Encharges et PV sur la ligne 1 ou 2 respectivement à votre domicile"
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "EC1_L1": {
      "val": "L1 EC1",
      "info": "Lorsqu’ils sont fermés, les relais EC1 L1 et L2 connectent vos batteries ou votre IQ8 PV à vos charges domestiques. Ils fonctionnent de phase à phase et n’ont pas de neutre."
    },
    "EC1_L2": {
      "val": "L2 EC1"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "Les relais L1 et L2 des IQ Battery, lorsqu’ils sont fermés, connectent vos batteries à vos charges domestiques. Ils fonctionnent de ligne à ligne et ne comportent pas de neutre."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "Une fois fermés, les relais PV L1 et L2 connectent vos systèmes IQ8 PV à vos charges domestiques. Ils fonctionnent ligne à ligne et ne possèdent aucun fil du neutre."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "Une fois fermés, les relais PV L1 et L2 connectent vos systèmes IQ PV à vos charges domestiques. Ils fonctionnent ligne à ligne et ne possèdent aucun fil du neutre."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "L1 du NFT",
      "info": "NFT est le transformateur à point neutre. Il garantit que votre système peut fonctionner en mode hors réseau. Le relais L1 du NFT, lorsqu’il est fermé, alimente votre NFT. Le relais N du NFT, lorsqu’il est fermé, connecte le neutre du NFT à vos charges domestiques."
    },
    "NFT_N": {
      "val": "N du NFT"
    },
    "GID_L1": {
      "val": "L1 GID",
      "info": "Les relais L1 et L2 du GID, lorsqu’ils sont fermés, connectent votre générateur à vos charges domestiques."
    },
    "GID_L2": {
      "val": "L2 GID"
    },
    "NFT_L2": {
      "val": "L2 du NFT",
      "info": "NFT est le transformateur à point neutre. Il garantit que votre système peut fonctionner en mode hors réseau. Le relais L2 du NFT, lorsqu’il est fermé, alimente votre NFT. Le relais N du NFT, lorsqu’il est fermé, connecte le neutre du NFT à vos charges domestiques."
    },
    "DER1_L1": {
      "val": "L1 DER1",
      "info": "Lorsqu’ils sont fermés, les relais DER1 L1 et L2 connectent vos batteries ou votre IQ8 PV à vos charges domestiques. Ils fonctionnent de phase à phase et n’ont pas de neutre."
    },
    "DER1_L2": {
      "val": "L2 DER1"
    },
    "DER2_L1": {
      "val": "L1 DER2",
      "info": "Les relais L1 et L2 DER2, lorsqu’ils sont fermés, connectent vos PV IQ8 à vos charges domestiques. Ils fonctionnent de ligne à ligne et ne comportent pas de neutre."
    },
    "DER2_L2": {
      "val": "L2 DER2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Ces relais, lorsqu’ils sont fermés, connectent vos charges à la source d’alimentation.​"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Les relais de ressource d’énergie distribuée (DER) DER L1, DER L2, DER L3 et DER N, lorsqu’ils sont fermés, connectent votre IQ Battery et IQ Microinverter sur la ligne 1, 2, 3 et Neutre respectivement à votre domicile."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Les relais de ressource d’énergie distribuée (DER) DER L1, DER L2 et DER N, lorsqu’ils sont fermés, connectent votre IQ Battery et IQ Microinverter sur la ligne 1, 2 et Neutre respectivement à votre domicile."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Les relais de ressource d’énergie distribuée (DER) DER L1 et DER N, lorsqu’ils sont fermés, connectent votre IQ Battery et IQ Microinverter sur la ligne 1 et Neutre respectivement à votre domicile"
    },
    "open": "Ouvert",
    "closed": "Fermé"
  }, _defineProperty(_liveVitalStats, "powered", "Alimenté"), _defineProperty(_liveVitalStats, "notPowered", "Non alimenté"), _defineProperty(_liveVitalStats, "niu", "Non utilisé"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "L1, L2 EC1"), _defineProperty(_liveVitalStats, "infoNftL1N", "L1, N du NFT"), _defineProperty(_liveVitalStats, "infoGidL1L2", "L1, L2 GID"), _defineProperty(_liveVitalStats, "infoNftL2N", "L2, N du NFT"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "L1, L2 DER1"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "L1, L2 DER2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "La différence entre la tension et la fréquence du réseau public et du micro-réseau s’observe grâce à la chute de tension sur l’appareil d’interconnexion du micro-réseau (MID)."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "Ce schéma fonctionnel du contrôleur du système est fourni à titre d’illustration uniquement."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Relais du contrôleur du système"), _defineProperty(_liveVitalStats, "bmuWarning", "BMU avertissement"), _defineProperty(_liveVitalStats, "bmuL1Error", "BMU erreur de niveau 1"), _defineProperty(_liveVitalStats, "bmuL2Error", "BMU erreur de niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Élément de batterie avertissement de tension maximum"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Élément de batterie avertissement de tension minimum"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Élément de batterie avertissement de déséquilibre de la tension"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Interrupteur FET de batterie avertissement de surtension"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Élément de batterie Tension maximum erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Élément de batterie Tension minimum erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Élément de batterie Température maximum erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Élément de batterie Température minimum erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Décharge de surintensité erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "Aucune communication du BMU."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Transistor à effet de champ Courant erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Fusible ouvert erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Transistor à effet de champ d’attaque erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Tension Circuit de mesure à distance ouvert erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Transistor à effet de champ Surchauffe erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Ligne thermique ouverte erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Circuit 24V de précharge erreur de niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Élément de batterie de précharge tension erreur de niveau"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Élément de batterie Tension maximum erreur de niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Élément de batterie Tension minimum erreur de niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Élément de batterie Température maximum erreur de niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Élément de batterie Température minimum erreur de niveau 2"), _defineProperty(_liveVitalStats, "gridMode", "Mode réseau"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Raccordé au réseau",
    "info": "La batterie est en mode connecté au réseau. Dans cet état temporaire, elle ne formera pas de micro-réseau si le réseau n’est pas disponible.",
    "pcuInfo": "Le micro-onduleur est en mode connecté au réseau. Il ne formera pas un micro-réseau quand le réseau n’est pas disponible."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "Sur le réseau",
    "info": "La batterie est en mode connecté au réseau et peut former un micro-réseau lorsqu’elle en a besoin.",
    "pcuInfo": "Le micro-onduleur est en mode connecté au réseau et est capable de former un micro-réseau au besoin."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Hors réseau",
    "info": "La batterie a formé un micro-réseau.",
    "pcuInfo": "Le micro-onduleur a formé un micro-réseau."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Îlot détecté",
    "info": "La batterie a détecté que le réseau est instable/n’est pas disponible. Elle est en train de former le micro-réseau.",
    "pcuInfo": "Le micro-onduleur a détecté que le réseau est instable / indisponible. Il est en train de former le micro-réseau."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Formation d’un micro-réseau",
    "info": "La batterie vient de redémarrer. Elle a détecté que le réseau électrique n’est pas disponible et est en train de former le micro-réseau. La réduction de la charge domestique aide à la formation du micro-réseau.",
    "pcuInfo": "Le micro-onduleur vient de redémarrer. Il a détecté que le réseau public n’est pas disponible et est en train de former le micro-réseau. Réduire la charge domestique aide la formation du micro-réseau."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Invalide",
    "info": "Mode réseau non valide reçu pour la batterie.",
    "pcuInfo": "Mode réseau invalide reçu pour le micro-onduleur."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "Modes réseau"), _defineProperty(_liveVitalStats, "ledStatus", "Statut LED"), _defineProperty(_liveVitalStats, "phase", "Phase"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "Chaque batterie contient %{pcuLength} micro-onduleurs IQ8X-BAT."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Une valeur de puissance (kW) positive du micro-onduleur indique que la batterie se décharge tandis qu’une valeur de puissance (kW) négative indique que la batterie se charge."), _defineProperty(_liveVitalStats, "infoPcuMicro", "Micro-onduleurs IQ8X-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "Micro-onduleurs IQ8D-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "Sur chaque batterie, il y a %{pcuLength} IQ8D-BAT micro-onduleurs."), _defineProperty(_liveVitalStats, "pcu", "Micro"), _defineProperty(_liveVitalStats, "enph_oper_state", "État"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Inactif"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "Démarrage"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Recherche via courant porteur en ligne (CPL) en cours"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normal (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normal (rafale)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Fonctionne en mode tension DC constante"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normal (Veille)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Arrêt (Défaut de protection)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Arrêt (Défaut du réseau)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normal (Vérification DCR)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Inconnu"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Défaut du firmware"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Désactivé (Arrêt de l’hôte)"
  }), _defineProperty(_liveVitalStats, "ac_power", "Énergie AC"), _defineProperty(_liveVitalStats, "signalStrength", "Force du signal"), _defineProperty(_liveVitalStats, "commOk", "Communication Ok"), _defineProperty(_liveVitalStats, "noComm", "Aucune communication"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Inconnu"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "Statut LED",
    "code": {
      "-1": "Inconnu",
      "0": "L’erreur nécessite un service",
      "1": "Erreur BMU L1",
      "2": "Température élevée",
      "3": "DC sur OFF",
      "4": "Aucune communication avec la passerelle",
      "5": "Communications connectées mais non testées",
      "6": "Communications connectées et testées",
      "7": "Échec de la mise à niveau",
      "8": "Mise à jour du BC en cours",
      "9": "Mise à jour du BMU en cours",
      "10": "Mise à jour du PCU en cours",
      "11": "Mode veille",
      "12": "Chargement",
      "13": "Déchargement",
      "14": "La capacité de la batterie est comprise entre : 75-100 %",
      "15": "La capacité de la batterie est comprise entre : 50-75 %",
      "16": "La capacité de la batterie est comprise entre : 25-50 %",
      "17": "La capacité de la batterie est comprise entre : 0-25 %",
      "18": "Système UP"
    },
    "enpowerRow": {
      "code": {
        "-1": "Inconnu",
        "0": "Erreur du contrôleur du système (Connecté au réseau)",
        "1": "Erreur du contrôleur du système (Déconnecté du réseau)",
        "2": "Le contrôleur du système est en arrêt rapide/mode commande manuelle",
        "3": "Contrôleur du système déconnecté du réseau ; DER déconnectés",
        "4": "Contrôleur du système opérationnel, ne peut détecter aucune IQ Battery sur CAN (Connecté au réseau)",
        "5": "Contrôleur du système opérationnel, ne peut pas détecter au moins une IQ Battery sur CAN (Connecté au réseau)",
        "6": "Contrôleur du système opérationnel, ne peut pas détecter au moins une IQ Battery sur CAN (Déconnecté du réseau)",
        "7": "Contrôleur du système déconnecté du réseau ; Réalisation d’une récupération SoC",
        "8": "Le contrôleur du système se synchronise au réseau",
        "9": "Mise à niveau FW du contrôleur du système (Connecté au réseau)",
        "10": "Mise à niveau FW du contrôleur du système (Déconnecté du réseau)",
        "11": "Contrôleur du système ON, Démarrage",
        "12": "Contrôleur du système ON et connecté au réseau",
        "13": "Contrôleur du système ON et déconnecté du réseau",
        "14": "Contrôleur du système OFF"
      }
    },
    "info": {
      "safetyIssue": "Aucune des voyants LED n'indique un problème de sécurité",
      "title": {
        "flashingRed": "Voyant rouge clignotant",
        "flashingYellow": "Voyant jaune clignotant",
        "softPulseYellow": "Voyant jaune clignotant lentement",
        "softPulseBlue": "Voyant bleu clignotant lentement",
        "softPulseGreen": "Voyant vert clignotant lentement",
        "solidRed": "Voyant rouge fixe",
        "solidYellow": "Voyant jaune fixe",
        "solidBlueOrGreen": "Voyant bleu ou vert fixe",
        "ledOff": "Off"
      },
      "desc": {
        "flashingRed": "La mise à jour a échoué ou la batterie est en état d’erreur. Contactez votre installateur ou l’assistance Enphase.",
        "flashingYellow": "Mise à jour en cours.",
        "softPulseYellow": "Mode sommeil activé.",
        "softPulseBlue": "Déchargement.",
        "softPulseGreen": "Chargement.",
        "solidRed": "Démarrage.",
        "solidYellow": "Ne fonctionne pas en raison d'une température élevée. Voir \"Dépannage de l’IQ Battery\" A pour plus de détails.",
        "solidBlueOrGreen": "Inactif. Les couleurs passent de bleu à vert selon l’état de charge. Le statut de charge est mis à jour dans l’application Enphase. Voir \"Dépannage de l’IQ Battery\" C pour plus de détails.",
        "ledOff": "Ne fonctionne pas. Consultez la section \"Dépannage d’IQ Battery\" B pour plus de détails."
      }
    }
  },
  "updatePending": {
    "title": "Téléchargement des données en cours",
    "content": "Votre passerelle télécharge les données de votre système vers le cloud d’Enphase. Cela se produit lorsque la passerelle est hors ligne depuis un certain temps. En général, cela prend une heure pour chaque jour où la passerelle est hors ligne. Ne vous inquiétez pas, le message disparaîtra une fois que toutes les données auront été téléchargées.",
    "envoyDataTitle": "Téléchargement de données",
    "envoyDataContent": "Votre système s'est récemment reconnecté à Internet et a besoin de temps pour télécharger vos données. Cela pouvait prendre jusqu'à une heure pour chaque jour où il était hors ligne."
  },
  "bkpConfig": {
    "title": "Configuration de Sauvegarde",
    "0": "Non sélectionné",
    "1": "Sauvegarde partielle de la maison",
    "2": "Sauvegarde Complète"
  },
  "set": "sélectionner",
  "change": "Modifier",
  "allTopics": "Tous les sujets",
  "referFriends": {
    "title": "Parrainer des amis",
    "subTitle_1": "pour qu’ils reçoivent ",
    "subTitle_2": " et recevez également ",
    "description_1": "Votre ami et vous pourrez recevoir la carte cadeau de ",
    "description_2": " une fois que votre ami aura acheté et activé un nouveau système photovoltaïque ou de stockage Enphase en utilisant le lien ci-dessous. ",
    "description_3": " une fois que votre ami aura acheté et activé un nouveau système photovoltaïque Enphase en utilisant le lien ci-dessous. ",
    "urlHeading": "Votre URL de parrainage",
    "shareButton": "Partagez votre lien de parrainage",
    "copyButton": "Copiez votre lien de parrainage",
    "termsConditions": "Conditions générales",
    "applyTerms": "appliquer.",
    "toastMessage": "Lien de parrainage copié dans votre presse-papier",
    "shareMessage_1": "Hé ! Sais-tu que ma maison est alimentée à l’énergie solaire ? Si tu pensais à passer au solaire, c’est le bon moment. J’ai un lien de parrainage exclusif que tu peux utiliser pour recevoir ",
    "shareMessage_2": " lorsque tu actives un nouveau système photovoltaïque Enphase.",
    "shareMessageAU_1": "Hey! Getting Enphase solar for my home is one the best investments I've made so I'm sharing the sunshine. If you’re considering ways to lower your electricity bills and protect your pocket, I have a referral link that you can use to receive ",
    "shareMessageAU_2": " when you go solar with Enphase. Check it out:",
    "tncTitle": "Conditions générales du programme de parrainage Enphase :",
    "important_title": "Importante",
    "important_subtitle": "Vous et votre ami ne serez éligibles au bon que si:",
    "important_1": "Il y a un intervalle d'au moins 15 jours entre l'enregistrement terminé et l'installation.",
    "important_2": "L'adresse e-mail avec laquelle la référence est reçue ou enregistrée est utilisée pour activer le système, une fois installé",
    "tnc": {
      "1": "Limite de 30 parrainages par client.",
      "2": "Les personnes parrainées doivent utiliser le lien que vous partagez et fournir leurs informations de contact à Enphase via le site web Enphase désigné au plus tard le 31 décembre 2022.",
      "3": "Si Enphase ou ses installateurs possèdent déjà l’identifiant email de la personne parrainée dans sa base de données, la personne parrainée ne pourra participer à ce programme de parrainage.",
      "4": "Vous et votre personne parrainée pourrez recevoir les cartes-cadeaux uniquement si votre personne parrainée achète, installe et termine l’activation de son produit Enphase dans les 2 ans suivant la réception par Enphase des informations du filleul sur le site d’Enphase.",
      "5": "Après réception de l’avis d’Enphase que la personne parrainée et vous pouvez recevoir la carte cadeau, vous devez demander la carte cadeau dans les 90 jours suivant ledit avis.",
      "6_One": "Si les cartes cadeaux de ",
      "6_Two": " ne sont pas disponibles, Enphase doit les remplacer par un prix de valeur égale ou supérieure.",
      "7": "Le montant sélectionné de la carte cadeau reflète une estimation de la valeur de la personne parrainée par rapport aux dépenses marketing économisées pour le recrutement d’un nouveau client.",
      "8": "Si la personne parrainée ou vous souhaitez vous retirer du programme de parrainage ou de la réception de la carte cadeau, veuillez contacter Enphase",
      "9": "Enphase ne sera tenu responsable des demandes confuses, incorrectes, incomplètes ou tardives, tout comme Enphase ne sera tenu responsable des erreurs typographiques, des problèmes de téléchargement des informations du parrainage ou de tout autre dysfonctionnement technique ou de réseau, des problèmes relatifs à Internet, à l’équipement électronique ou aux sites web.",
      "10": "Enphase se réserve le droit de modifier, suspendre ou résilier ce programme de parrainage sans préavis.",
      "11": "Ce programme de parrainage est interdit là où prohibé.",
      "12": "Afin qu’Enphase puisse accorder un parrainage, le lien unique doit être utilisé à la fois par la personne parrainée et vous-même.",
      "13": "Il doit y avoir un intervalle d'au moins 15 jours entre l'enregistrement terminé et l'installation.",
      "14": "L'adresse e-mail avec laquelle la référence est reçue ou enregistrée doit être utilisée pour activer le système, une fois installé."
    }
  },
  "contactPVMaintainer": "Contacter un agent d’entretien des panneaux photovoltaïques",
  "contactStorageMaintainer": "Contacter un agent d’entretien des éléments de stockage",
  "pvInstallerDetails": "Détails de l’installateur des panneaux photovoltaïques",
  "storageInstallerDetails": "Détails de l’installateur des éléments de stockage",
  "customerSupport": "l’assistance clientèle",
  "soFarToday": "À ce jour,",
  "forSelectedPeriod": "Pour la période sélectionnée,",
  "energyIndependence": {
    "title": "Indépendance énergétique",
    "subTitle": "Mesure votre niveau d’indépendance du réseau public",
    "formulaText": "Calcul de l’indépendance énergétique:",
    "formula": "[1-(Importé/Consommé)] * 100%",
    "formulaForGenerator": "[1 - {(Importé du réseau + Importé du générateur) / Consommé}] * 100 %",
    "desc1": "L’indépendance énergétique est une mesure de l’autosuffisance énergétique. Elle se définit par le fait que vous puissiez personnellement répondre à tous vos besoins en énergie.",
    "unknown": "niveau indéterminé, car votre système n’a communiqué aucune donnée de consommation.",
    "0": "l’intégralité de votre consommation énergétique est alimentée par une source externe telle que le réseau public. Par conséquent, votre score d’indépendance énergétique pour %{periodValue} %{eiValue}%.",
    "100": "aucune partie de votre consommation énergétique n’est alimentée par une source externe telle que le réseau public. Par conséquent, votre score d’indépendance énergétique pour %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% de votre consommation énergétique est alimentée par une source externe telle que le réseau public. Par conséquent, votre score d’indépendance énergétique pour %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "aujourd’hui est de",
    "forSelectedPeriod": "la période sélectionnée est de",
    "addStorageTitle": "Ajouter du stockage",
    "addStorage": "pour augmenter votre indépendance énergétique.",
    "addStorageTitleWB": "Ajouter du solaire ou du stockage",
    "addStorageWB": "augmente votre indépendance énergétique.",
    "clarify": "L'indépendance énergétique n'inclut pas l'énergie exportée et ne doit pas être confondue avec le Net Metering (ou Net Energy), qui est la différence entre l'énergie importée et exportée"
  },
  "backupHistory": {
    "backupEvents": "Total des événements en autonomie"
  },
  "eventHistory": {
    "totalEvents": "Total des événements",
    "events": "Article/Événement",
    "deviceImpacted": "Appareil touché",
    "recommendedAction": "Action recommandée",
    "noBackupHistoryFound": "Aucun historique de sauvegarde trouvé",
    "eventStatus": "Statut de l’événement"
  },
  "siteActivationStage": {
    "title": " a lancé l'activation de votre système Enphase, ",
    "learnToUse": "Découvrez comment vous pouvez utiliser l’application Enphase pour surveiller votre nouveau système Enphase."
  },
  "sfdcChatBot": {
    "exitConfirmation": "Voulez-vous vraiment fermer le Discute avec nous?",
    "sfdcChatSubject": "Messagerie instantanée de l’application Enphase",
    "offlineSupport": "Malheureusement, nos agents sont hors ligne. Merci de nous laisser un message."
  },
  "pushN": {
    "ok": "Ok, vas-y",
    "stay": "Reste ici",
    "permMsg": "Vous avez reçu une notification pour le site %{siteName}. Accédez à ce site pour afficher la notification."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Quel mode devrais-je choisir?",
    "autofillRatePlanExistFAQ": "Pourquoi ma grille tarifaire ne figure-t-elle pas dans la liste?",
    "autofillRatePlanMatchFAQ": "Pourquoi mes données ne correspondent-elles pas à ma facture?",
    "autofillTariffNote": "Si vous rencontrez des difficultés à identifier le nom ou le code du tarif, veuillez contacter votre fournisseur d’électricité pour plus d’informations.",
    "whtBaslineElecRate": "Quel est votre taux de rémunération de l’électricité de base ? ",
    "doElecPayRateVaryWeekends": "Votre taux de rémunération de l’électricité est-il différent le weekend ? ",
    "doElecPayRateVarySeasonaly": "Votre taux de rémunération de l’électricité varie-t-il selon les saisons ? ",
    "elecPayGoesUpWithUsage": "Votre taux de rémunération de l’électricité augmente en fonction de votre utilisation ? ",
    "pRatePeakOffPecakChanges": "Votre taux de rémunération de l’électricité comporte des heures de pointe et des heures creuses ? ",
    "ratePerUnitOfSolar": "Quel est votre taux de rémunération par unité d’énergie solaire générée ? ",
    "payOutRate": "Taux de rémunération ",
    "tarifeditorConstants1": "Structure tarifaire de l’électricité ",
    "tarifeditorConstants2": "Convertit les données d’énergie en taux de devise équivalents ",
    "tarifeditorConstants3": "Voir/Éditer la structure tarifaire de l’électricité de votre service public ",
    "tarifeditorConstants4": "Vous pouvez vérifier les informations relatives au taux d’importation d’électricité dans la facture fournie par votre service public sous la section détaillant vos frais d’électricité. ",
    "tarifeditorConstants5": "Ajouter un taux d’importation d’électricité ",
    "tarifeditorConstants6": "Définissez la structure tarifaire qui vous est facturée par votre service public pour l’importation d’électricité depuis le réseau. ",
    "tarifeditorConstants7": "Note ",
    "tarifeditorConstants8": "Les informations sur les tarifs de l’électricité sont utilisées par la passerelle pour déterminer le meilleur calendrier de charge et de décharge des batteries lorsque votre profil de batterie est réglé sur « Mode Économies ». Modifier ces informations changera le comportement du système.",
    "tarifeditorConstants9": "La structure tarifaire de l’électricité n’est pas ajoutée ",
    "tarifeditorConstants10": "Ajouter un taux d’importation d’électricité ",
    "tarifeditorConstants11": "Sélectionner un mode pour ajouter vos détails ",
    "tarifeditorConstants12": "Remplir automatiquement ",
    "tarifeditorConstants13": "Importer votre structure tarifaire de l’électricité en utilisant les informations tirées de votre service public ",
    "tarifeditorConstants14": "Manuel ",
    "tarifeditorConstants15": "Saisir manuellement les détails de la structure tarifaire de l’électricité de votre service public ",
    "tarifeditorConstants16": "Code postal ",
    "tarifeditorConstants17": "Nom de la compagnie ",
    "tarifeditorConstants18": "Nom du tarif / Code ",
    "tarifeditorConstants19": "Détails du taux d’importation d’électricité ",
    "tarifeditorConstants20": "Forfait ",
    "tarifeditorConstants21": "Tarification différenciée ",
    "tarifeditorConstants22": "Heure de consommation ",
    "tarifeditorConstants23": "Tarif fixe ",
    "tarifeditorConstants24": "Clause de non-responsabilité ",
    "tarifeditorConstants25": "Les tarifs électriques rapportées sont les prestations regroupées qui n’incluent que les composants tarifaires basés sur la consommation. Les frais fixes les ajustements les crédits les avantages les tarifs régionaux ou spécifiques ainsi que les taxes ne sont pas pris en compte. ",
    "tarifeditorConstants26": "Confirmer & Enregistrer ",
    "tarifeditorConstants27": "Nom des tarifs d’électricité ",
    "tarifeditorConstants28": "Tarifs d’électricité de base ",
    "tarifeditorConstants29": "Êtes-vous sûr de vouloir réinitialiser les détails ? ",
    "tarifeditorConstants30": "Vos tarifs d’électricité comportent des heures de pointe et des heures creuses ? ",
    "tarifeditorConstants31": "Vos tarifs d’électricité augmentent en fonction de votre utilisation ? ",
    "tarifeditorConstants32": "Tarifs fixes d’électricité qui ne varient pas. ",
    "tarifeditorConstants33": "Les tarifs d’électricité augmentent en fonction de l’utilisation. ",
    "tarifeditorConstants34": "Est-ce que vos tarifs d’électricité varient selon les saisons ? ",
    "tarifeditorConstants35": "Est-ce que vos tarifs d’électricité sont différents le weekend ? ",
    "tarifeditorConstants36": "Quels sont vos tarifs d’électricité de base ? ",
    "tarifeditorConstants37": "Tarifs fixes d’électricité qui ne varient pas. ",
    "tarifeditorConstants38": "La structure tarifaire de l’électricité ne varie que selon les saisons. ",
    "tarifeditorConstants39": "La structure tarifaire de l’électricité est différente le weekend. ",
    "tarifeditorConstants40": "La structure tarifaire de l’électricité varie selon les saisons et également le weekend. ",
    "tarifeditorConstants41": "Les tarifs d’électricité augmentent en fonction de l’utilisation. ",
    "tarifeditorConstants42": "Tarifs d’électricité de base : ",
    "tarifeditorConstants43": "La structure tarifaire de l’électricité ne varie que selon les saisons. ",
    "tarifeditorConstants44": "Les tarifs d’électricité comportent des heures de pointe et des heures creuses. ",
    "tarifeditorConstants45": "La structure tarifaire de l’électricité n’est différente que le weekend. ",
    "tarifeditorConstants46": "Ajouter un taux d’exportation d’électricité ",
    "tarifeditorConstants47": "Ajoutez la structure tarifaire pour la rémunération de l’électricité générée par panneaux photovoltaïques que vous exportez vers le réseau. ",
    "tarifeditorConstants48": "Sélectionnez votre plan d’exportation d’électricité ",
    "tarifeditorConstants49": "Comment sélectionnez votre plan d’exportation d’électricité ",
    "tarifeditorConstants50": "Vous pouvez vérifier ces informations sur la facture émise par votre service public sous la section détaillant vos crédits et ajustements. ",
    "tarifeditorConstants51": "NEM (Mesurage de l’énergie net) ",
    "tarifeditorConstants52": "Cochez ceci si vous avez une configuration de compteur net chez vous. <b style='font-weight: bold;'>Votre taux d’importation d’électricité sera copié comme taux d’exportation d’électricité.</b> ",
    "tarifeditorConstants53": "FIT net (Tarif de subventionnement net) ",
    "tarifeditorConstants54": "Cochez ceci si vous n’êtes rémunéré que pour l’énergie solaire qui retourne au réseau depuis votre domicile. ",
    "tarifeditorConstants55": "FIT brut (Tarif de subventionnement brut) ",
    "tarifeditorConstants56": "Cochez ceci si vous êtes rémunéré pour chaque unité d’électricité générée par vos panneaux photovoltaïques. ",
    "tarifeditorConstants57": "Autre ",
    "tarifeditorConstants58": "Cochez ceci si vous bénéficiez d’un autre plan. ",
    "tarifeditorConstants59": "Détails du taux d’exportation d’électricité ",
    "tarifeditorConstants60": "Structure de tarification de rémunération de l’électricité ",
    "tarifeditorConstants61": "Plan d’exportation ",
    "tarifeditorConstants62": "Modifier le taux d’exportation de l’électricité ",
    "tarifeditorConstants63": "Votre plan FIT vous rémunère à un prix fixe par unité d’énergie solaire exportée ? ",
    "tarifeditorConstants64": "Taux variant selon le temps ",
    "tarifeditorConstants65": "Le taux de rémunération de l’électricité comporte des heures de pointe et des heures creuses ",
    "tarifeditorConstants66": "Le taux de rémunération fixe de l’électricité ne varie pas ",
    "tec67": "Taux de remboursement électrique de base",
    "tec68": "Nom du tarif",
    "tec69": "Nous sommes désolés de vous informer que votre structure tarifaire n’est pas compatible avec le remplissage automatique. Nous essayons actuellement de résoudre ce problème. En attendant, vous pouvez configurer votre tarification grâce au flux manuel.",
    "tec70": "Impossible de récupérer le nom du service public pour votre code postal. Veuillez configurer manuellement la tarification.",
    "tec71": "Désolés, nous ne sommes pas parvenus à récupérer les détails de tarification.",
    "tec72": "Sélectionner le nom du service public",
    "tec73": "Recherche",
    "tec74": "Nom/Code de tarification",
    "tec75": "Sélectionner un nom/code de tarification",
    "tec76": "Configurer manuellement la tarification",
    "tec77": "Réessayer",
    "tec78": "Sélectionner la durée de chargement",
    "tec79": "Charger les batteries à partir du réseau",
    "from": "De",
    "to": "À",
    "tec80": "Mise à jour réussie de la charge des batteries à partir du réseau",
    "try_again": "Réessayez.",
    "tec81": "Notez votre expérience",
    "tec82": "Ces données étaient-elles utiles et précises?",
    "tec83": "Pas du tout",
    "tec84": "Tout à fait",
    "tec85": "Si vous avez des questions, ou besoin de plus d’informations, n’hésitez pas à nous écrire.",
    "tec86": "Vous ne voulez pas que vos batteries se chargent à partir du réseau ?",
    "tec87": "Thank you for your valuable feedback",
    "talc": "Veuillez réessayer plus tard.",
    "tec88": "Quelle est votre expérience avec l’éditeur de tarification?",
    "tec89": "Remarque",
    "tec90": "Copier depuis la tarification d’achat",
    "tec91": "Copier vos paramètres de tarification depuis la tarification d’achat définie",
    "tec92": "Tarif d’exportation de l’électricité",
    "tec93": "Tarif d’importation de l’électricité",
    "tec94": "Les tarifs de l’électricité indiqués ici sont groupés conformément aux composants tarifaires illustrés ci-dessous.",
    "tec95": "Répondez aux questions ci-dessous pour définir votre type de tarification.",
    "tec96": "Période non valide",
    "tec97": "%{time1} - %{time2} est déjà sélectionné",
    "peak": "Pic",
    "aPeak": "Ajouter un pic",
    "aSeason": "Ajouter la saison",
    "season": "Saison",
    "eSeason": "Modifier la saison",
    "tec98": "Saisie non valide. La valeur doit être supérieure au niveau %{index}",
    "tec99": "Une erreur s’est produite, veuillez réessayer plus tard",
    "tec100": "Les taux de remboursement de l’électricité augmentent en même temps que l’utilisation.",
    "tec101": "Taux variable dans le temps",
    "tier": "Niveau",
    "offPeak": "Heures creuses",
    "tec102": "Modifier le tarif d’importation de l’électricité",
    "tec103": "configuration manuelle",
    "tec104": "Remplir automatiquement tarif",
    "tec105": "Sélectionner un mode",
    "tec106": "Sélectionner un mode pour modifier vos détails",
    "tec107": "sélectionner le nom de la tarification",
    "tec108": "Les informations sur les tarifs de l’électricité sont utilisées par la passerelle pour déterminer le meilleur calendrier de charge et de décharge des batteries. Modifier ces informations changera le comportement du système.",
    "tec109": "Les informations des tarifs de l’électricité sont utilisées pour calculer vos économies d’énergie dans le temps et vous donnent des recommandations personnalisées pour vous aider à faire des économies sur vos coûts énergétiques.",
    "tec110": "Quel est votre taux de rémunération par unité d’énergie solaire exportée?",
    "tec111": "Tarif d’importation de l’électricité ajouté avec succès",
    "tec112": "Tarif d’importation de l’électricité mis à jour avec succès",
    "tec113": "Tarif d’importation de l’électricité réinitialisé avec succès",
    "tec114": "Tarif d’exportation de l’électricité ajouté avec succès",
    "tec115": "Tarif d’exportation de l’électricité mis à jour avec succès",
    "tec116": "Tarif d’exportation de l’électricité réinitialisé avec succès",
    "rate": "Tarif",
    "tec117": "Taux de paiement fixe",
    "tec118": "Autre (Tarification différenciée )",
    "tec119": "Autre (Heure de consommation )",
    "tec120": "Autre (Forfait )",
    "tec121": "Gross FIT",
    "tec122": "Net FIT (Taux variable dans le temps)",
    "tec123": "Net FIT (Forfait )",
    "tec124": "NEM",
    "tec125": "Tarifs fixes d’électricité qui ne varient pas. La structure tarifaire de l’électricité ne varie que selon les saisons.",
    "tec126": "Tarifs fixes d’électricité qui ne varient pas. La structure tarifaire de l’électricité n’est différente que le weekend.",
    "tec127": "Tarifs fixes d’électricité qui ne varient pas. La structure tarifaire de l’électricité varie selon les saisons et également le weekend.",
    "tec128": "Le taux de rémunération fixe de l’électricité ne varie pas. La structure tarifaire de l’électricité ne varie que selon les saisons.",
    "tec129": "Le taux de rémunération fixe de l’électricité ne varie pas. La structure tarifaire de l’électricité n’est différente que le weekend.",
    "tec130": "Le taux de rémunération fixe de l’électricité ne varie pas. La structure tarifaire de l’électricité varie selon les saisons et également le weekend.",
    "tec131": "Les tarifs d’électricité comportent des heures de pointe et des heures creuses. La structure tarifaire de l’électricité ne varie que selon les saisons.",
    "tec132": "Les tarifs d’électricité comportent des heures de pointe et des heures creuses. La structure tarifaire de l’électricité n’est différente que le weekend.",
    "tec133": "Les tarifs d’électricité comportent des heures de pointe et des heures creuses. La structure tarifaire de l’électricité varie selon les saisons et également le weekend.",
    "tec134": "Le taux de rémunération de l’électricité comporte des heures de pointe et des heures creuses. La structure tarifaire de l’électricité ne varie que selon les saisons.",
    "tec135": "Le taux de rémunération de l’électricité comporte des heures de pointe et des heures creuses. La structure tarifaire de l’électricité n’est différente que le weekend.",
    "tec136": "Le taux de rémunération de l’électricité comporte des heures de pointe et des heures creuses. La structure tarifaire de l’électricité varie selon les saisons et également le weekend.",
    "tec137": "Les tarifs d’électricité augmentent en fonction de l’utilisation. La structure tarifaire de l’électricité ne varie que selon les saisons.",
    "tec138": "Les taux de remboursement de l’électricité augmentent en même temps que l’utilisation. La structure tarifaire de l’électricité ne varie que selon les saisons.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Afficher l’historique des taux (% des niveaux de charge)",
    "tec141": "Le taux d’importation d’électricité a bien été ajouté",
    "tec142": "Veuillez noter votre expérience d’ajout du taux d’électricité",
    "tec143": "Insatisfait",
    "tec144": "Satisfait",
    "tec145": "Ignorer",
    "tedc0": "Frais de demande",
    "tedc1": "Frais de demande pour toute la journée (24 heures)",
    "tedc2": "Votre tarif d’électricité inclut des frais de demande, ajoutés mensuellement à votre facture d’électricité.",
    "tedc3": "Votre tarif d’électricité comprend une composante de charge de demande. Pendant les heures de pointe, la consommation maximale pour tout intervalle de %{time}-minutes pendant le mois sera facturée selon les détails suivants",
    "tedc4": "Consommation de %{time} min max.",
    "tedc5": "Choisir une structure tarifaire d'électricité",
    "tet1": "Parlez-moi de l’augmentation du tarif d’électricité",
    "tet2": "Dans certaines régions, le coût de l’électricité fluctue tout au long de la journée ou en fonction de la quantité que vous consommez. Nous utilisons votre tarif d’électricité pour planifier le meilleur calendrier de charge et de décharge de batterie lorsque son profil est sur Mode d’économie.",
    "tet3": "Démarrage",
    "tet4": "Appuyer sur « Ajouter le tarif d’importation d’électricité ».",
    "tet5": "Entrez vos informations",
    "tet6": "Utiliser Remplissage automatique ou Manuel pour entrer les détails de votre tarif. Vous pourriez avoir besoin d’une facture d’électricité à jour si vous entrez votre tarif manuellement.",
    "tet7": "Remplissage automatique",
    "tet8": "Sélectionnez votre Fournisseur et votre Nom ou Code d’abonnement dans les menus déroulants. L’application recherchera automatiquement votre tarif d’importation d’électricité.",
    "tet9": "Manuel",
    "tet10": "Entrer les détails dans chaque champ — vous devrez peut-être consulter une facture d’électricité récente pour recueillir toutes les informations nécessaires.",
    "tet11": "Ajouter un tarif d’exportation d’électricité",
    "tet12": "Si vous obtenez un crédit pour renvoyer l’électricité au réseau, ajoutez ensuite votre tarif d’exportation d’électricité. Appuyer sur « Ajouter le tarif d’exportation d’électricité » pour commencer — Vous aurez les mêmes options pour entrer vos informations par remplissage automatique ou manuellement.",
    "tet13": "Comment déterminer et utiliser votre tarif d’électricité",
    "undefined": "autre (plusieurs niveaux)",
    "timeDiffError": "L’heure de départ et de fin doivent avoir un écart minimum de 15 mins",
    "periodOverlapError": "La période chevauche l’une des autres périodes",
    "peakConflictError": "Le taux maximal doit être supérieur au taux minimal",
    "isTimeValid": "L'heure de début doit être antérieure à l'heure de fine"
  },
  "appliance": {
    "info": "Pour garder votre domicile alimenté pendant de longues périodes au cours d’une panne de courant, nous vous recommandons de minimiser et de gérer votre consommation d’énergie",
    "desc": "Éteignez les charges domestiques non critiques pour augmenter la durée de vie de la batterie.",
    "descSystem2_0AndEncharge": "Meilleures pratiques pendant une panne du réseau.",
    "largeAppliances": "Gros électroménagers",
    "useSparingly": "Utiliser avec parcimonie",
    "essentialAppliances": "Appareils essentiels",
    "useNormally": "Utiliser normalement",
    "airConditioner": "Climatiseur",
    "dishwasher": "Lave-vaisselle",
    "poolPump": "Pompe de piscine",
    "washingMachine": "Machine à laver",
    "electricVehicle": "Véhicule électrique",
    "electricDryer": "Sécheuse électrique",
    "lights": "Lumières",
    "laptop": "Ordinateur portable",
    "television": "Télévision",
    "refrigerator": "Réfrigérateur",
    "wifiRouter": "Routeur Wi-Fi",
    "microwave": "Four micro onde"
  },
  "rootedAlert": {
    "exitBtn": "Quitter",
    "proceedBtn": "Continuer",
    "agreeBtn": "J’accepte",
    "warningLabel": "AVERTISSEMENT!",
    "warningTextInitial": "Votre appareil semble être rooté. Cela compromet la protection de sécurité par défaut et rend vulnérables les données stockées sur votre appareil. Il n’est pas recommandé d’exécuter l’application Enphase sur un appareil rooté.",
    "warningTextFinal": "En poursuivant, je comprends et j’accepte qu’Enphase ne soit pas responsable des dysfonctionnements ou des conséquences de l’exécution de l’application Enphase sur cet appareil rooté."
  },
  "generator": {
    "exerciseModeOverlap1": "Le temps d'exercice chevauche la période d'inactivité",
    "exerciseModeOverlap2": "pour",
    "exerciseModeOverlap3": "Voulez-vous continuer ?",
    "dayInWeek": "Jour dans  semaine",
    "time": "Heure",
    "duration": "Durée",
    "frequency": "Speichern",
    "save": "Speichern",
    "edit": "BEARBEITEN",
    "cancelRequest": "Anfrage stornieren",
    "activate": "Aktivieren",
    "okayText": "Gut, habe ich verstanden!",
    "batteryUnavailable": "<span>Ihr System hat kein Akku. Möchten Sie Ihren Generator basierend auf der Akku-Ladung steuern? <a href='https://estimator.enphaseenergy.com/login' target='_blank'>Speicher hinzufügen</a></span>",
    "suspendedStateText": "Votre générateur est actuellement désactivé. Activez votre générateur en utilisant le bouton à bascule en haut de l’écran pour activer le profil du générateur.",
    "suspendedModalHeading": "Votre générateur sera désactivé.",
    "suspendedModalHeading_1": "Votre générateur sera activé en fonction du profil sélectionné.",
    "suspendedModalSubheading": "Pour activer le générateur, veuillez utiliser le bouton à bascule en haut de l’écran.",
    "infoHeadng": "Générateur",
    "infoSubheading": "<div><div>Lorsqu’il est<span style='color: #F37320'>Aktiviert</span>, votre générateur s’activera et se désactivera selon le profil sélectionné et la disponibilité du réseau. Si votre système est connecté au réseau, votre générateur sera désactivé indépendamment des profils sélectionnés.</div><div style='margin-top: 10px;'> Vous pouvez désactiver votre générateur lorsqu’il n’est pas utilisé, par exemple lorsque vous partez en vacances.<div></div>",
    "advancedSettings": "Paramètres avancés",
    "pendingRequest": "demande en attente",
    "disabled": "Deaktiviert",
    "disable": "Désactiver",
    "enabled": "Aktiviert",
    "waiting": "Warten auf Informationen",
    "active": "Aktiv",
    "deviceDetails": "Sélectionnez un profil intelligent pour contrôler votre %{manufacturer} %{modelNumber}.",
    "autoStart": "Démarrage automatique",
    "autoStartSubheading": "Utilisez-le si vous voulez activer votre générateur dès que votre système passe en mode hors réseau",
    "batteryOptimizationSubheading": "Utilisez-le si vous voulez activer votre générateur lorsque la charge de la batterie est inférieure à un certain niveau et que votre système est hors réseau.",
    "batteryChargeThreshold": "Seuil de charge de la batterie",
    "lowerLimit": "Limite inférieure: ",
    "upperLimit": "Limite supérieure: ",
    "start": "Démarrer: ",
    "stop": "Arrêter: ",
    "addQuietTime": "Ajouter un temps calme",
    "quietTime": "Temps calme",
    "quietTimeToggle": "Utilisez-le si vous ne voulez pas activer votre générateur pendant cette période. Lorsque la batterie atteint la limite critique, le générateur sera activé indépendamment du temps calme.",
    "startTime": "Heure de début: ",
    "endTime": "Heure de fin: ",
    "criticalChargeSettings": "Paramètres de charge critique:",
    "exerciseMode": "Übungseinstellungen",
    "generatorLoadingToast": "La confirmation de l’état du générateur prend plus de temps que prévu. Veuillez vérifier ultérieurement.",
    "exerciseModeSubheading": "Ceci est utilisé pour faire fonctionner le générateur automatiquement à un intervalle régulier pour le garder en bonne condition de fonctionnement.",
    "batteryOptimization": "Démarrage selon le niveau de la batterie",
    "activateBatteryProfile": "Vous avez sélectionné le profil Démarrage automatique. Veuillez activer le profil \"Démarrage selon le niveau de la batterie\" pour ajouter le temps calme",
    "manualMode": "Mode manuel",
    "manualModeDescription": "Votre générateur fonctionne actuellement en mode manuel. Veuillez changer le mode de votre générateur en mode automatique ou contactez votre installateur.",
    "generatorStartLimit": "La limite de démarrage ne peut être inférieure à 10 %.",
    "generatorStartStopLimit": "La limite de démarrage et la limite d’arrêt de la charge de la batterie doivent avoir un écart minimum de 5 %.",
    "generatorLimitDescription": "Utilisez cette fonction pour éviter d'allumer votre générateur pendant des périodes spécifiques. Le générateur est mis en marche lorsque la charge de la batterie passe en dessous de la limite de charge critique.",
    "generatorQuietTime": "État silencieux",
    "generatorNormalTime": "Temps normal",
    "generatorEnableGenerator": "Activer le générateur",
    "generatorDisableGenerator": "Désactiver le générateur",
    "automatic": "Automatique",
    "ecoFriendly": "Écologique"
  },
  "sgipStatic": {
    "applyForIncentive": "Demander une prime SGIP",
    "subheadingSgip": "Les propriétaires de systèmes situés en Californie, qui prévoient d’acheter ou ont acheté une batterie Enphase pour leur domicile, peuvent faire une demande de SGIP (programme d’incitation à l’autoproduction)",
    "applyNow": "Demander maintenant",
    "learnMore": "En savoir plus",
    "serviceFee": "* Des frais de service peuvent s’appliquer",
    "enphaseRepresentative": "* Vous pouvez être contacté par un représentant d’Enphase par téléphone/email.",
    "documentsRequired": "Les documents suivants sont nécessaires pour demander la prime SGIP :",
    "documentHeading1": "1. Dernières factures de services publics (Au moins une facture pour les 3 derniers mois)",
    "documentHeading2": "2. Document contractuel",
    "additionalInfo": "* Des documents supplémentaires peuvent être exigés avant le versement final de la prime."
  },
  "activationProgress": {
    "systemActivationInProgress": "L’activation de votre système est en cours",
    "completed": "Terminé",
    "viewDetails": "Voir les détails",
    "activationCompleted": "L’activation est terminée à 100 %",
    "activationInProgress": "Activation en cours",
    "devices": "Appareils",
    "status": "Status",
    "envoy": "Passerelle",
    "encharge": "Batterie",
    "enpower": "Contrôleur du système",
    "pvProduction": "Production des PV",
    "cosumptionCT": "CT de consommation",
    "systemOperational": "Système opérationnel",
    "reporting": "Envoie des rapports",
    "notReporting": "N’envoie pas de rapport",
    "enabled": "Activé",
    "notEnabled": "Non activé",
    "producing": "Produit de l’énergie",
    "verified": "Vérifié",
    "notVerified": "Non vérifié",
    "featuresNowEnable": "Les fonctions suivantes sont maintenant activées.",
    "featuresWillBeEnabled": "Les fonctions suivantes seront maintenant activées une fois l’activation de votre système terminée :",
    "consumptionMonitoring": "Suivi de consommation",
    "liveStatus": "Statut en direct",
    "stormGuard": "Protection contre les tempêtes",
    "batteryProfileSetting": "Paramètres du profil de la batterie",
    "gridControl": "Contrôle du réseau"
  },
  "prodIssue_faq_1": "Pourquoi l’un de mes panneaux produit moins que les autres?",
  "prodIssue_faq_2": "Il est courant pour des panneaux installés sur le même toit d’avoir une génération d’énergie qui varie. De nombreux facteurs peuvent provoquer ces variations, tels que la direction du panneau, l’ombre provoquée par les cheminées des arbres et d’autres obstructions.",
  "accountNew": {
    "account": {
      "title": "Vos informations",
      "title_alternate": "Informations personnelles",
      "save_changes": "Enregistrer les modifications",
      "name_label": "Nom :",
      "phone_label": "Mobile:",
      "phone_placeholder": "Numéro de téléphone",
      "first_name_placeholder": "Prénom",
      "last_name_placeholder": "Nom",
      "email_placeholder": "Adresse électronique",
      "email_label": "E-mail :",
      "change_password": "Modifier le mot de passe",
      "current_password": "Mot de passe actuel :",
      "password_label": "Nouveau mot de passe :",
      "password2_label": "Saisir à nouveau le mot de passe :",
      "password_footnote": "Les mots de passe doivent se composer d'au moins 6 caractères et contenir au moins 1 chiffre ou caractère spécial.",
      "cancel_change_password": "Ne pas modifier le mot de passe",
      "units_label": "Unités :",
      "units_metric": "Métrique (°C, km)",
      "units_us": "Impérial (°F, mi)",
      "locale_label": "Langue",
      "equivalent_label": "Équivalent énergétique :",
      "equivalent_display": "Commencer par",
      "notification_label": "E-mails :",
      "preference_monthly_email": "M'envoyer des récapitulatifs mensuels des performances du système",
      "preference_enphase_email": "Envoyez-moi des newsletters, des promotions et des enquêtes sur les services ou les produits Enphase.",
      "production_issues_email": "M'avertir de la production du système ou des problèmes liés au service",
      "save_successful": "Vos informations ont été enregistrées.",
      "save_successful_email": "Vos informations ont été enregistrées. Reportez-vous à la remarque ci-dessous à propos de la modification de votre adresse électronique.",
      "save_failed": "Vos informations n'ont pas été enregistrées.",
      "system_info": "Informations système pour %{site_name}",
      "system_weather": "Système météorologique",
      "show_system_weather": "Afficher les fonctions météorologiques pour ce site",
      "save": "Enregistrer"
    },
    "system_preferences": {
      "title": "Préférences système",
      "name_label": "Nom :",
      "public_label": "Page du système public :",
      "public_text_html": "Créer une page publique pour mon système",
      "public_preview_link": "Aperçu de la page publique",
      "public_help_link": "En savoir plus",
      "public_footnote": "Cela activera les fonctionnalités de partage social et permettra aux visiteurs d'accéder à votre système.",
      "display_label": "Afficher le nom du système :",
      "save_changes": "Enregistrer les préférences système",
      "save_location_changes": "Enregistrer les paramètres de confidentialité",
      "save_successful": "Vos préférences système ont été enregistrées.",
      "save_failed": "Les préférences du système n'ont pas été enregistrées."
    },
    "validations": {
      "required": "Ce champ est obligatoire.",
      "password_too_short": "Votre mot de passe doit comporter au moins six caractères et doit contenir au moins un chiffre ou un caractère spécial.",
      "password_too_long": "Saisissez moins de 50 caractères.",
      "password_similar_to_username": "Votre mot de passe ne peut pas être identique à votre adresse électronique.",
      "password_too_weak": "Votre mot de passe doit comporter au moins six caractères et doit contenir au moins un chiffre ou un caractère spécial.",
      "password_weak": "Votre mot de passe doit comporter au moins six caractères et doit contenir au moins un chiffre ou un caractère spécial.",
      "password_good": "Niveau de sécurité du mot de passe : Bon",
      "password_strong": "Niveau de sécurité du mot de passe : Élevé",
      "password_policy": "Votre mot de passe doit contenir entre %{pwd_min_length} et %{pwd_max_length} caractères, dont %{digit_in_pwd} chiffres, %{uppercase_in_pwd} majuscules, %{lowercase_in_pwd} minuscules, %{special_character_in_pwd} caractères spéciaux (uniquement ~!@#$%^&*)",
      "equalTo": "Veuillez fournir encore la même valeur.",
      "invalid_phone_number": "Veuillez fournir un numéro de téléphone portable valide.",
      "empty_phone_number": "Veuillez fournir votre numéro de téléphone portable.",
      "email_used": "L'adresse électronique est déjà enregistrée. Réessayez avec une autre adresse e-mail ou $cHere pour réinitialiser votre mot de passe.",
      "emailInvalid": "Veuillez saisir une adresse e-mail valide."
    }
  },
  "accountDelete": {
    "deleteAccount": "Supprimer le compte",
    "deletePopUpText": "Votre compte et les informations personnelles associées seraient supprimés. Vous serez déconnecté après la suppression du compte. Voulez-vous poursuivre?",
    "deleteCnfText": "Votre compte et les informations personnelles associées seraient supprimées, à l'exception des informations que nous sommes tenus de conserver en relation avec votre système énergétique. Vous serez déconnecté après la suppression du compte. Voulez-vous poursuivre?",
    "yes": "Oui",
    "no": "Non",
    "verificationCode": "Le code de vérification",
    "enterCodeText": "Entrez le code à 4 chiffres qui a été envoyé à votre adresse e-mail enregistrée et le numéro de téléphone mobile.",
    "didntReceive": "Vous n'avez pas reçu de code ?",
    "resend": "Renvoyer",
    "deleteCnfTextEnlm": "Votre compte et les informations personnelles associées seraient supprimées, à l'exception des informations que nous sommes tenus de conserver en relation avec votre système énergétique. Vous perdrez également l'accès à Enlighten Manager. Vous serez déconnecté après la suppression du compte. Voulez-vous poursuivre?",
    "deleteAdmin": "Votre compte ne peut pas être supprimé car vous êtes un utilisateur administrateur Enphase",
    "verifyCode": "Vérifier le code",
    "logOutText": "Vous serez déconnecté après avoir vérifié le code.",
    "confirmText": "Votre compte est désactivé. Nous conserverons les informations personnelles relatives à votre système énergétique pour honorer votre garantie et prendre en charge votre système.",
    "ok": "Ok, j'ai compris",
    "activateCnfText": "Votre compte Enphase n'est pas actif car vous avez supprimé votre compte. Souhaitez-vous l'activer à nouveau ?",
    "activateText": "L'identifiant de messagerie est enregistré auprès d'Enphase. Cependant, il n'est pas actif car il a été supprimé.",
    "click": "Cliquez sur ",
    "activateAgain": "ici pour l'activer à nouveau",
    "activateAccount": "Activer le compte",
    "emailIDRegistered": "L'identifiant de messagerie est enregistré auprès d'Enphase. Cependant, il n'est pas actif car il a été supprimé. $cHere pour l'activer à nouveau.",
    "deleteAccountPopupText": "La suppression de votre compte désactivera votre compte et supprimera toutes les informations personnelles associées à votre compte. Étant donné que vous êtes associé à un système énergétique Enphase, nous sommes tenus de conserver vos informations personnelles afin de prendre en charge la garantie du produit, les mises à niveau du système et l'assistance.",
    "learnMore": "Learn MoreApprendre encore plus",
    "accountdeletion": "Votre compte est en cours de suppression. Ce processus peut prendre jusqu'à 30 jours et vous pouvez créer un nouveau compte après la suppression de votre compte précédent.",
    "incorrectEmailandPass": "L'e-mail et le mot de passe que vous avez saisis ne correspondent pas à nos enregistrements. Veuillez réessayer.",
    "accountdeletioninfo": "Votre compte est en cours de suppression. Cela peut prendre jusqu'à 30 jours.",
    "WOAccntdeletePopup": "La suppression de votre compte désactivera votre compte et supprimera toutes les informations personnelles associées à votre compte.",
    "accountdelReq": "Demande de suppression de compte",
    "verfcodedel": "Votre code de vérification pour la suppression du compte Enphase",
    "accountActvReq": "Demande d'activation de compte",
    "codedelAccount": "Code de vérification pour la suppression du compte Enphase",
    "codeDuration": "Ce code ne sera valable que 15 minutes.",
    "userDelReq": "L'utilisateur a demandé l'option de suppression de compte dans l'application Enphase. Veuillez trouver les détails de l'utilisateur ci-dessous",
    "requestReceived": "Nous avons reçu votre demande d'activation de votre compte Enphase. Pour ce faire, cliquez sur le lien ci-dessous dans les 7 jours suivant la réception de cet e-mail.",
    "activate": "Activer",
    "accActivate": "activez votre compte",
    "optdelaccount": "Votre code de vérification pour la suppression du compte Enphase est %{otp}. Ce code est valable 15 minutes.",
    "emailCheckInstruction": "S'il vous plaît vérifier votre e-mail pour obtenir des instructions pour activer le compte."
  },
  "phase": {
    "all": "Vue triphasée",
    "phaseL": "Phase L",
    "msgOffGrid": "Les données de consommation électrique par phase ne sont pas disponibles lorsque votre système est déconnecté du réseau."
  },
  "vls": {
    "vlsHeading": "Niveau d’arrêt de la batterie",
    "shutdownLevelLine1": "En cas de panne, votre batterie s’arrêtera à",
    "shutdownLevelLine1-2": "charge pour conserver de l’énergie. Elle redémarre en utilisant l’énergie conservée lorsque le réseau public restaure le courant ou lorsque les panneaux solaires reprennent la production d’énergie.",
    "shutdownLevelLine2": "Choisissez une valeur élevée si vous subissez des intempéries qui ont un impact sur la production d’énergie solaire.",
    "vlsWarning": "Le niveau d’arrêt des batteries ne peut être supérieur à la réserve de la batterie (%{soc}%)",
    "stormVlsWarning": "L’alerte orage est activée pour votre système. Une fois que l’alerte orage est finie, la réserve de la batterie sera mise à jour sur %{soc}% puisque la réserve ne peut être inférieure au niveau d’arrêt",
    "batteryReserveWarning": "La réserve de la batterie ne peut être définie sur une valeur inférieure au niveau d’arrêt de la batterie (%{horizontal}%). Veuillez réduire le niveau d’arrêt de votre batterie à partir des #Paramètres avancés# pour réduire la réserve de la batterie.",
    "editRequest": "Vous avez une demande active. Veuillez attendre la confirmation ou annuler cette demander pour continuer la sélection."
  },
  "defaultLocale": {
    "popContent1": "Choisissez la langue de l'application",
    "popContentBody1": "Souhaitez-vous continuer avec ",
    "popContentBody2": " comme langue de votre application ?",
    "button1": "D'accord, continuez",
    "button2": "Choisissez une autre langue",
    "button3": "Non, changez en ",
    "en": "Anglais",
    "de": "Allemand",
    "es": "Espagnol",
    "fr": "Français",
    "it": "italien",
    "nl": "Néerlandais",
    "pl": "polonais",
    "pt": "Portugais",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "Aucun tableau !",
    "noArraysDesc": "Vous n’avez pas de panneaux solaires installés",
    "noAccessConsumptionData": "Vous n’avez pas accès aux données de consommation de ce site."
  },
  "drEventsActive": "RD – Évènement : Actif",
  "pleaseGoTo": "Veuillez accéder à ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " pour mettre à jour vos préférences de notification.",
  "loadControl": {
    "enabled": "Activé",
    "disabled": "Désactivé",
    "smartEnabled": "Contrôle intelligent activé",
    "smartDisabled": "Contrôle intelligent désactivé",
    "offGridBehaviour": "Comportement hors réseau",
    "modeDetails": "Détails du mode Contrôle intelligent",
    "newModeDetails": "Détails du mode de contrôle des charges",
    "basicMode": "Mode basique",
    "cannotUse": "%{loadName} ne peut être utilisée​",
    "genOnUSe": "%{loadName} peut être utilisée lorsque le générateur est allumé",
    "genMode": "Mode générateur",
    "batteryMode": "Mode batterie",
    "batteryModePercent": "%{loadName} peut être utilisée lorsque la charge de batterie est à %{lowerSoc}% ou plus.​",
    "batteryModeSoc": "Si la charge passe en dessous de %{lowerSoc}%, %{loadName} ne peut être utilisée jusqu’à ce que la batterie soit rechargée à %{upperSoc}%.",
    "loadControlHeading": "Contrôler l’alimentation de vos charges lorsque vous êtes déconnecté du réseau",
    "loadControlSubHeading": "Toutes les charges seront alimentées lorsque vous êtes connecté au réseau",
    "powered": "Alimenté",
    "notPowered": "Non alimenté",
    "unknown": "Inconnu",
    "permissionOfIntstaller": "Vous n’avez pas l’autorisation de modifier les paramètres de cet appareil. Veuillez contacter votre installateur ou l’assistance clientèle Enphase pour en savoir plus.",
    "willbePowered": "Votre %{loadName} sera toujours alimentée dans cet état.",
    "poweredOnOffGrid": "Votre %{loadName} sera alimentée selon le comportement Déconnecté du réseau sélectionné.",
    "continueModal": "Voulez-vous continuer ?",
    "infoDetails": "Lorsque le contrôle intelligent est désactivé ou lorsque votre système est connecté au réseau, les charges seront toujours alimentées.",
    "newInfoDetails": "Contrôler l’énergie de vos charges selon les ressources en énergie ou l’heure du jour. Vous pouvez également utiliser le mode Manuel si vous voulez contrôler l’énergie de vos charges instantanément.",
    "enableSmartComtrol": "Assurez-vous que vos interrupteurs pour ces appareils sont activés pour utiliser cette fonctionnalité.",
    "enableToggle": "Aktivieren Contrôle intelligent?",
    "disableToggle": "Désactiver Contrôle intelligent?",
    "apply": "Appliquer",
    "modalPara1": "<div>Lorsque le contrôle intelligent est <span style='color: #F37320'>activé</span>, vous pouvez choisir l’un des trois modes pour le comportement Déconnecté du réseau.</div>",
    "disabledModalText": "La fonction de contrôle intelligent est désactivée pour cette charge. Veuillez activer la fonction de contrôle intelligent à l'aide du bouton à bascule pour mettre à jour le comportement hors réseau",
    "batteryChargeLowerLimit": "La limite inférieure de la charge de la batterie ne peut pas être inférieure à 10 %.",
    "batteryChargeHigherLimit": "La limite inférieure de la charge de la batterie ne peut être supérieure à 90 %",
    "loadControlLoadingToast": "La confirmation du statut de %{loadName} prend plus longtemps que prévu. Veuillez vérifier à nouveau plus tard.",
    "loadControlTakingLonger": "La confirmation du statut de la charge prend plus longtemps que prévu. Veuillez vérifier à nouveau plus tard.",
    "batteryChargeLowerHigherLimit": "La limite inférieure et la limite supérieure de la charge de la batterie doivent avoir un écart minimum de 5 %",
    "mode": "Mode",
    "lcMainHeading": "Contrôlez l’énergie attribuée à vos charges",
    "basic": "basique",
    "scheduled": "programmé",
    "advanced": "avancé",
    "manual": "manuel",
    "notSelected": "Non sélectionné",
    "poweredWhen": "Alimenté lorsque la charge de la batterie est supérieure à",
    "poweredGenOn": "Alimenté lorsque le générateur est allumé",
    "poweredBetweenTime": "Alimenté entre %{startTime} et %{endTime}",
    "onceDisconnected": "Une fois déconnectée de la source d’énergie, la charge ne sera pas alimentée à moins que la batterie ne se recharge à 100%.",
    "alwaysPowered": "Toujours alimenté",
    "neverPowered": "Jamais alimenté",
    "minDiff": "L’Heure de début et l’Heure de fin doivent comporter un intervalle minimum de 15 min.",
    "startLessThanEnd": "L’heure de début doit être inférieur à l’heure de fin",
    "notValidTime": "L’heure de début et l’heure de fin doivent se trouver entre %{startTime} et %{endTime}.",
    "completed": "Le mode de %{loadName} a bien été mis à jour.",
    "notCompleted": "Votre demande n’a pas pu être traitée. Veuillez réessayer plus tard.",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "Aucun contrôle de charge trouvé",
    "allowedWarning": "Lorsque vous modifiez cette fenêtre de temps, veuillez vous assurer que votre production d’énergie solaire est suffisante pour prendre en charge votre consommation pendant cette fenêtre de temps.",
    "advancedMode": {
      "subtitle": "Contrôler la charge en utilisant:",
      "notPowered": "Alimenté lorsque la charge est supérieure à ",
      "batterySocDesc1": "Non alimenté lorsque la charge descend en dessous de ",
      "batterySocDesc2": "Alimenté uniquement après que la batterie se soit rechargée à ",
      "batterySocDesc3": " (même si le générateur est allumé)",
      "notAvailable": "Non disponible",
      "onGridGenPowered": "Alimenté",
      "offGridGenPowered": "Alimenté lorsque le générateur est allumé"
    }
  },
  "app_info": {
    "update_available": "Mise à jour de l'application disponible",
    "already_updatec": "Votre application est à jour",
    "update_now": "Mettre à jour",
    "latest_update": "Dernière mise à jour",
    "update_history": "Historique des mises à jour",
    "show_more": "Afficher plus",
    "show_less": "Afficher moins"
  },
  "s1": "Aidez-moi à sélectionner un profil",
  "s2": "Découvrir les profils de batterie",
  "s3": "Me suggérer un profil",
  "s4": "La charge de la batterie est supérieure à la réserve",
  "s5": "Indépendance énergétique après les heures pleines :",
  "s6": "Pendant les heures creuses, vos panneaux solaires rechargeront d’abord votre batterie avant d’alimenter votre maison. Toute énergie solaire excédentaire sera renvoyée au réseau pour réduire votre facture d’électricité.",
  "s7": "Si votre maison a besoin de plus d’énergie que vos panneaux solaires, l’électricité sera utilisée à partir du réseau.",
  "s8": "Comportement du système pendant les heures pleines",
  "s9": "Réduisez votre facture d’électricité",
  "s10": "Dans certaines régions, le coût de l’électricité fluctue tout au long de la journée, devenant plus élevé pendant les heures pleines lorsque la demande en électricité est élevée.",
  "s11": "Pour éviter d’acheter de l’électricité à un coût plus élevé, votre maison utilisera la batterie. Si votre maison a besoin de plus d’énergie que la batterie ne peut en fournir, l’énergie solaire est utilisée en priorité et le réseau est utilisé en dernier recours. Tout énergie solaire excédentaire serait exportée vers le réseau.",
  "s12": "La nuit, lorsque vos panneaux solaires ne produisent pas d’énergie, votre maison utilise celle accumulée dans votre batterie jusqu’à ce qu’elle atteigne son niveau de charge de réserve.",
  "s13": "De l’électricité est importée depuis le réseau lorsque l’énergie solaire n’est pas disponible et que votre maison demande plus de puissance que ce que les batteries peuvent fournir.",
  "s14": "Alimentez votre maison avec de l’énergie propre",
  "s15": "Votre maison accordera la priorité à l’utilisation d’énergie propre. Pendant la journée, l’énergie solaire alimente la maison, puis la batterie prend la relève. Toute énergie excédentaire est exportée vers le réseau. Pendant la nuit, la batterie alimente la maison.",
  "s16": "De l’électricité est importée depuis le réseau lorsque votre maison demande plus de puissance que l’énergie solaire et les batteries ne peuvent en fournir ensemble.",
  "s17": "La batterie est complètement chargée",
  "s18": "Comportement du système pendant les heures creuses",
  "s19": "Vos panneaux alimenteront d’abord votre batterie, puis votre maison. Toute l’énergie supplémentaire sera envoyée au réseau.",
  "s20": "Pendant la nuit ou chaque fois que vous avez besoin de plus d’énergie que vos panneaux ne peuvent en produire, votre maison utilise l’électricité du réseau. Votre batterie n’est jamais utilisée, sauf en cas de panne d’électricité.",
  "s21": "Appuyer sur un profil pour accéder à ses pages.",
  "s22": "Faire glisser le pointeur vers la gauche ou vers la droite pour en savoir plus.",
  "s23": "Vos batteries se déchargeront même après les heures pleines.",
  "s24": "De l’électricité est importée depuis le réseau lorsque l’énergie solaire n’est pas disponible et que votre maison demande plus de puissance que ce que les batteries peuvent fournir.",
  "s25": "Comportement du système pendant les heures creuses",
  "s26": "Restez alimenté pendant les pannes",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Il s’agit du montant estimé des économies financières réalisées par votre système en fonction de la production photovoltaïque. Cette valeur est calculée en fonction des tarifs d’électricité saisis.",
      "noTeriffMsg": "Ajouter le tarif de l'électricité pour connaître vos économies",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Commencer",
      "billingCycle": {
        "more": "supérieure au dernier cycle de facturation à la même période",
        "less": "inférieure au dernier cycle de facturation à la même période",
        "same": "À peu près identique au dernier cycle de facturation à la même période"
      },
      "calendarMonth": {
        "more": "plus que cette fois le mois précédent",
        "less": "moins que cette fois la semaine précédente",
        "same": "À peu près le même qu'à cette heure le mois précédent"
      },
      "day": {
        "more": "plus que cette fois la veille",
        "less": "moins que cette fois la veille",
        "same": "À peu près la même heure que la veille",
        "significantMore": "Nettement plus élevé que la veille"
      },
      "week": {
        "more": "plus que cette fois la semaine précédente",
        "less": "moins que cette fois la semaine précédente",
        "same": "À peu près au même moment que la semaine précédente"
      },
      "year": {
        "more": "plus que cette fois l'année précédente",
        "less": "moins que cette fois l'année précédente",
        "same": "À peu près le même qu'à cette époque l'année précédente"
      },
      "editElectricity": "MODIFIER LE TARIF D’ÉLECTRICITÉ",
      "viewSavingsBased": "Affichez les économies réalisées en fonction de",
      "calendarMonthTitle": "Mois calendaire",
      "calendarMonthDesc": "Période comprise entre le 1er du mois et le dernier jour du mois",
      "noExportRate": "Ajoutez %{exportCTA} pour afficher vos économies totales",
      "exportRate": "Taux d'exportation"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Impossible de se connecter localement",
    "limitedAppFunctionality": "Fonctionnalité d’application limitée",
    "needHelpGatewayWifi": "Besoin d’aide pour configurer la connectivité Wi-Fi de la passerelle",
    "howToConnectGatewayNetwork": "Comment se connecter au réseau de la passerelle",
    "connectGatewayToWifi": "Connecter la passerelle au réseau Wi-Fi",
    "connectLocally": "SE CONNECTER LOCALEMENT",
    "checkNetworkConnection": "Veuillez vérifier votre connexion réseau.",
    "noInternetModalSubText1": "Veuillez vérifier votre connexion réseau. Pendant ce temps, vous pouvez voir le statut actuel du système.",
    "noInternetModalSubText2": "Veuillez vérifier votre connexion réseau. En attendant, si vous êtes près de votre système, vous pouvez vous connecter localement à la passerelle pour voir l’état actuel.",
    "refereshing": "Rafraîchissement",
    "pullToReferesh": "Tirer pour rafraîchir",
    "connectionStatus": "Votre téléphone est maintenant connecté localement au réseau de la passerelle.",
    "connectivityErrorMsg1": "Veuillez vous assurer que votre téléphone et la passerelle sont sur le même réseau.",
    "connectivityErrorMsg2": 'La passerelle a été récemment connectée au réseau %{wifiName}',
    "connectivityErrorMsg3": "Vous pouvez également connecter votre téléphone au réseau Wi-Fi de la passerelle en activant le mode AP sur votre passerelle",
    "connecting": "Votre téléphone essaie de se connecter localement avec la passerelle pour afficher l’état en temps réel.",
    "viewLiveStatus": "Voir le statut en direct",
    "pleaseTryAgainInSomeTime": "Veuillez réessayer dans un moment.",
    "connectedLocally": "Connecté localement",
    "ssidNotMatchedError": "Vous n’avez pas connecté votre téléphone cellulaire au bon réseau de la passerelle. Veuillez connecter votre téléphone cellulaire au réseau de cette passerelle: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Réseau de passerelle pour ce site",
      "message": "Veuillez connecter votre téléphone cellulaire uniquement au réseau de l’une des passerelles de ce site. Voici les réseaux de la passerelle pour ce site:",
      "buttonText": "D’accord, j’ai compris !"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "Vous n’avez pas connecté votre téléphone cellulaire au bon réseau de passerelle. Veuillez connecter votre téléphone cellulaire unique au réseau de l’une des passerelles de ce site.",
    "configureButtonMultiEnvoyMsg": "Vous n’avez pas connecté votre téléphone cellulaire au bon réseau de la passerelle. Veuillez connecter votre téléphone cellulaire uniquement au réseau de l’une des passerelles de ce site. Voici les réseaux de la passerelle pour ce site:",
    "listOfGatewayNetworks": "Liste des réseaux de la passerelle pour ce site",
    "configureWifiMultiEnvoyMsg": "Pour configurer le Wi-Fi pour la passerelle (N° de série : XXXX), connectez votre mobile au mode AP de cette passerelle. Vous êtes actuellement connecté au mode AP de la passerelle (N° de série :XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "Comment se connecter au Wi-fi de la passerelle",
      "okGotIt": "D’accord, j’ai compris",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Connectez-vous au réseau de passerelle local si vous souhaitez modifier les paramètres de votre système.",
      "subText2": 'Assurez-vous que votre téléphone et la passerelle sont sur le même réseau %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(La passerelle a r\xE9cemment \xE9t\xE9 connect\xE9 au r\xE9seau \"%{lastConnection}\")",
      "subText3": "Sinon, connectez votre téléphone cellulaire au Wi-Fi des passerelles en activant le mode AP sur votre passerelle",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Connexions Wi-Fi récentes des passerelles",
      "gatewayPrefix": "N° de série de la passerelle",
      "gatewayBtn": "Réseaux Wi-Fi de la passerelle pour ce site",
      "alternetively": "Sinon, connectez votre téléphone à n’importe quel réseau de passerelle en activant le mode AP sur votre passerelle."
    },
    "isTouPopupMsg": "Le mode Économies ne peut être activé puisqu’il ne fonctionne que si vous avez un Compteur d’énergie nette (NEM) et votre tarif d’électricité varie en fonction de l’heure d’utilisation (ToU). Définir ou mettre à jour le tarif d’électricité n’est possible que lorsque votre téléphone est connecté à Internet.",
    "configWifiToGateway": "CONFIGUREZ LE WI-FI POUR VOTRE PASSERELLE",
    "phoneNtConnectedToGateway": "Votre téléphone n'est pas connecté à la passerelle",
    "chooseWifiNetwork": "Choisissez un réseau Wi-Fi que vous souhaitez utiliser avec votre passerelle.",
    "learnWifiConfigToGatway": "Découvrez comment configurer le Wi-Fi pour votre passerelle",
    "step": "Etape",
    "connectPhoneToGateway": "Connectez votre téléphone à la passerelle",
    "connectToGatewayNetwork": "Connectez-vous au réseau de la passerelle pour configurer le Wi-Fi pour votre passerelle",
    "gatewayNtReachable": "Votre passerelle n'est pas accessible",
    "pleaseEnsure": "Veuillez vous assurer:",
    "gatewayAPModeOn": "Le mode AP de la passerelle est activé",
    "phoneInCloseProximity": "Le téléphone est à proximité de la passerelle",
    "mobileDataOff": "Les données mobiles (données cellulaires) sont désactivées",
    "searchingGateway": "Recherche du réseau de passerelle…",
    "devicePluggedIn": "Assurez-vous que votre appareil est à proximité, branché et que le mode AP est activé",
    "connectingTo": "Connexion à",
    "reflectedInApp": "Cela peut prendre quelques minutes pour être reflété dans l'application",
    "connectionFailed": "Impossible de se connecter au réseau de la passerelle",
    "connectedToGateway": "Le téléphone est connecté à la passerelle"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Connecter la passerelle au Wi-Fi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Choisissez un réseau Wi-Fi auquel vous souhaitez connecter votre passerelle."), _defineProperty(_offline, "scanNetwork", "Analyser le réseau Wi-Fi"), _defineProperty(_offline, "enterPassword", "Entrez le mot de passe pour"), _defineProperty(_offline, "join", "Rejoindre"), _defineProperty(_offline, "gatewayConnected", "La passerelle est connectée à %{selectedWifi} avec succès"), _defineProperty(_offline, "disconnectPhoneFromGateway", "Vous pouvez maintenant déconnecter votre téléphone de votre réseau de passerelle et le connecter à votre Wi-Fi/activer vos données mobiles"), _defineProperty(_offline, "failedToConnect", "Impossible de connecter"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "PAssurez-vous que votre passerelle est connectée à une source d'alimentation et que vous êtes à proximité de votre passerelle."), _defineProperty(_offline, "routerIsOn", "Assurez-vous que votre routeur Wi-Fi est allumé et que vous êtes à proximité de votre routeur Wi-Fi"), _defineProperty(_offline, "unableToDisplayNetworks", "Impossible d'afficher les réseaux Wi-Fi"), _defineProperty(_offline, "errorDisplayingNetworks", "Une erreur s'est produite lors de l'affichage des réseaux Wi-Fi en raison de problèmes techniques. Veuillez réessayer."), _defineProperty(_offline, "errorInConnectingToWifi", "Une erreur s'est produite lors de la connexion au réseau Wi-Fi. Veuillez réessayer plus tard ou vous connecter à un autre réseau."), _defineProperty(_offline, "unableToConnect", "Impossible de se connecter"), _defineProperty(_offline, "pairGateway", "Associez la passerelle à votre téléphone via Bluetooth."), _offline),
  "tutorial": {
    "back": "Retour",
    "apMode": "Comment activer le mode AP",
    "step1": "Etape 1 sur 3",
    "step2": "Etape 2 sur 3",
    "step3": "Etape 3 sur 3",
    "powerOnGateway": "Allumer la passerelle",
    "title2": "Appuyez sur le bouton de mode AP",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Commencer",
    "next": "L'étape suivante",
    "prev": "Étape précédente",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "C'est ça!",
    "step1of2": "Etape 1 sur 2",
    "step2of2": "Etape 2 sur 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Essayons de connecter la passerelle à votre téléphone.Veuillez vous assurer que vous êtes à proximité de votre passerelle et que vos données cellulaires mobiles sont désactivées."
  }
};
module.exports = mobile;